import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, EventEmitter, NgModule, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, of } from 'rxjs';
import { FlightSearchBaseData, FlightSearchDestinationProperties, FlightSearchProperties, FlightSearchAirlineCodes, FlightSearchAirports, ChildAgeProps, InfantAgeProps, FlightSearchHistory, FlightSearchRights } from '../Models/FlightSearchProperties';
import { RevenueManagementAirlineCodes, RevenueManagementAirports, RevenueManagementBaseData, Supplier_OficeID } from '../Models/RevenueManagementProperties';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { BsDatepickerConfig, BsDaterangepickerConfig, BsDaterangepickerDirective, BsDaterangepickerContainerComponent } from 'ngx-bootstrap/datepicker';
import { NgSelectComponent } from '@ng-select/ng-select';
import { DxAutocompleteComponent } from 'devextreme-angular';
import { Local } from 'protractor/built/driverProviders';
import { Subscription, timer } from 'rxjs';
import { catchError, retry, map, filter } from 'rxjs/operators';
import { NewsAlertProperties, NotificationProperties } from '../Models/CmsContactUsProperties';
import { CMSService } from '../Services/cms.service';
import { NgbModal, ModalDismissReasons, NgbModalOptions, NgbModule } from '@ng-bootstrap/ng-bootstrap';
declare var $;
import DataSource from 'devextreme/data/data_source';
import ArrayStore from 'devextreme/data/array_store';
import { event } from 'devextreme/events';
import { DatePipe } from '@angular/common';
import { Input } from '@angular/compiler/src/core';
import { InputDecorator } from '@angular/core';
import { ElementRef } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { ImportPnrDetails, ImportPNREntryProprties, ImportRequest } from '../Models/ImportPnrProperties';

import { faPlaneArrival } from '@fortawesome/free-solid-svg-icons';
import { faPlaneDeparture } from '@fortawesome/free-solid-svg-icons';
import { GroupTicketProperties, GroupTicketSearchParameters } from '../Models/GroupTicketProperties';
import { GroupTicketShowRightCMS } from '../Models/CmsLoginDealsProperties';
import { GroupTicketService } from '../Services/groupTicket.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-flight-search',
  templateUrl: './flight-search.component.html',
  styleUrls: ['./flight-search.component.css'],
  providers: [BsDatepickerConfig, BsDaterangepickerConfig]
})


/** FlightSearch component*/
export class FlightSearchComponent {
  /** FlightSearch ctor */
  minDateRange: Date;
  maxDateRange: Date;
  constructor(private cd: ChangeDetectorRef, private flightService: FlightSearchService, private http: HttpClient, private ticketService: GroupTicketService,
    private router: Router, private cmsService: CMSService, private modelService: NgbModal, private activatedRoute: ActivatedRoute) {


  }
  @ViewChild('tbOnewayFrom', { static: false }) tbOnewayFromAuto: DxAutocompleteComponent
  @ViewChild('tbOnewayTo', { static: false }) tbOnewayToAuto: DxAutocompleteComponent;
  @ViewChild('tbRoundTripFrom', { static: false }) roundTripFromAuto: DxAutocompleteComponent
  @ViewChild('tbRoundTripTo', { static: false }) roundTripToAuto: DxAutocompleteComponent;
  @ViewChild('tbMulticityFrom', { static: false }) multicityFromAuto: DxAutocompleteComponent
  @ViewChild('tbMulticityTo', { static: false }) multicityToAuto: DxAutocompleteComponent;
  @ViewChild('tbRoundTripDeparting', { static: false }) tbRoundTripDepartingDate !: ElementRef<HTMLInputElement>;
  @ViewChild(BsDaterangepickerDirective, { static: false }) dateRangePicker: BsDaterangepickerDirective;
  //19-july-23
  importPnrEntryList$: ImportPNREntryProprties[];
  pccList$: Observable<Supplier_OficeID[]>;
  supplierId: string = "SPB_001";
  faCoffee = faPlaneDeparture;
  faCoffee1 = faPlaneArrival;
  airportName: string = "";
  filteredAirports: string[] = [];

  flightSearchRightsObj = new FlightSearchRights();
  groupObj!: any | Object;
  groupedAirports: any[] = [];
  filteredAirportsOW: string[] = [];
  selectedAirportOW: FlightSearchAirports = new FlightSearchAirports();
  airP: any[] = [];




  //end

  timerSubscription: Subscription;
  dataSource: any;
  airportList: FlightSearchAirports[] = [];

  popoverArray: boolean[] = [];




  groupTicketShowRightCMS = new GroupTicketShowRightCMS();
  primeShowModal: boolean = false;
  groupTicketSearch = new GroupTicketSearchParameters();
  groupTicketList: GroupTicketProperties[] | undefined;



  flightRes: any;
  searchObj = new FlightSearchProperties();
  onewaySearchObj = new FlightSearchProperties();
  roundtripSearchObj = new FlightSearchProperties();
  multiCitySearchObj = new FlightSearchProperties();
  destinationObj = new FlightSearchDestinationProperties();
  muldestinationObj = new FlightSearchDestinationProperties();
  isOneway: boolean = true;
  isRoundtrip: boolean = false;
  isMulticity: boolean = false;
  allBaseData$: FlightSearchBaseData;
  airlineList$: Observable<FlightSearchAirlineCodes[]>;
  airportData: string[] = [];
  datess = [];
  airLineData: FlightSearchAirlineCodes[] = [];
  lastkeydown1: number = 0;
  airportFromList: any;
  airportToList: any;
  onewayFrom: string = "";
  onewayTo: string = "";
  onewayFcity: string = "";
  onewayTcity: string = "";
  roundwayFcity: string = "";
  roundwayTcity: string = "";
  onewayDeparture: string = "";
  onewayDepartureDate: string = "";
  //twowayFrom: string = "";
  //twowayTo: string = "";
  //twowayDeparture: string = "";
  roundTripFrom: string = "";
  roundTripTo: string = "";
  roundTripDeparture: string = "";
  multiCityDeparture: string = "";
  multiwayFrom: string = "";
  defaultMulticityDiv: FlightSearchDestinationProperties[] = [];
  multicityList: FlightSearchDestinationProperties[] = [];
  date1: Date;
  date2: Date;
  maxDate = new Date();
  haveRights: boolean = false;
  IMPORTRights: boolean = false;
  closeResult = '';
  modalOptions: NgbModalOptions;
  childAgeObj = new ChildAgeProps();
  infantAgeObj = new InfantAgeProps();
  searchHistoryList: FlightSearchHistory[] = [];
  onewayOrigin: string = "";
  onewayDestination: string = "";
  importPNR = new ImportRequest();
  isPakistan: boolean = false;
  //new 07-june-2023
  returnDates: any;
  departureDates: any;
  //end

  timeList = [
    { time: "Any" },
    { time: "Morning" },
    { time: "Afternoon" },
    { time: "Night" },
    { time: "Midnight" },
  ];

  adultList = [
    { adultItem: 1 },
    { adultItem: 2 },
    { adultItem: 3 },
    { adultItem: 4 },
    { adultItem: 5 },
    { adultItem: 6 },
    { adultItem: 7 },
    { adultItem: 8 },
    { adultItem: 9 },
  ];

  childList: Number[] = [];
  infantList: Number[] = [];

  childAgeList = [
    { childAgeItem: 2 },
    { childAgeItem: 3 },
    { childAgeItem: 4 },
    { childAgeItem: 5 },
    { childAgeItem: 6 },
    { childAgeItem: 7 },
    { childAgeItem: 8 },
    { childAgeItem: 9 },
    { childAgeItem: 10 },
    { childAgeItem: 11 }
  ];
  infantAgeList = [
    { infantAgeItem: "less than 1" },
    { infantAgeItem: "1" }
  ];
  roundwayDuration: number;

  cabinClassList = [
    { cabinItem: "Economy" },
    { cabinItem: "Business" },
    { cabinItem: "First" },
    { cabinItem: "PremiumEconomy" },
  ];

  fareTypeList = [
    { fareItem: "Low Fares" },
    { fareItem: "Refundable" },
    { fareItem: "Non-Refundable" },
  ];

  OnewayContentRedy() {
    this.tbOnewayFromAuto.instance.focus();
  }
  RoundtripContentRedy() {
    this.roundTripFromAuto.instance.focus();
  }
  //multicityContentRedy() {
  //  this.multicityFromAuto.instance.focus();
  //}


  isAG01: boolean;

  ngOnInit() {
    this.minDateRange = new Date();
    this.maxDateRange = new Date();
    this.minDateRange.setDate(this.minDateRange.getDate() + 0);
    this.maxDateRange.setDate(this.maxDateRange.getDate() + 365);
    //this.onewaySearchObj.nearByAirport = true;
    //this.roundtripSearchObj.nearByAirport = true;
    //this.multiCitySearchObj.nearByAirport = true;
    this.isPakistan = environment.isPakistan;
    if (localStorage.getItem("ImmediateParent") == "AG01")
      this.isAG01 = true;
    else
      this.isAG01 = false;
    this.timerSubscription = timer(0, 1800000).pipe(
      map(() => {
        this.getActiveNews(); // load data contains the http request
        this.getFlightSearchHistory();

      })
    ).subscribe();
    this.notiPop();
    this.AddPassengerList();
    this.AddDefaultFlights();
    this.GetSearchBaseData();
    this.GetAllGroupTicket();
    //this.getAirportsOnInput();
    //this.flightService.GetFlightBaseData().subscribe(data)


  }
  filterAirportsOW(event: any) {


    let filteredOW: string[] = [];
    let query = event.query.toLowerCase();
    for (let i = 0; i < this.airportList.length; i++) {
      let airportOW = this.airportList[i];
      if (airportOW.iatA_CODE.toLowerCase().startsWith(query) || airportOW.city.toLowerCase().startsWith(query)) {
        if (airportOW.iatA_CODE.toLowerCase() === query) {
          filteredOW[0] = airportOW.airportName;
        }
        filteredOW.push(airportOW.airportName);
      }
    }
    filteredOW = [...new Set(filteredOW)];
    this.filteredAirportsOW = filteredOW;
  }


  toggleWithAnimationOptions(index: number) {
    this.popoverArray[index] = !this.popoverArray[index];
  }
  filterAirports(event: any) {
    let filtered: string[] = [];
    let query = event.query.toLowerCase();
    for (let i = 0; i < this.airportList.length; i++) {
      let airport = this.airportList[i];
      if (airport.iatA_CODE.toLowerCase().startsWith(query) || airport.city.toLowerCase().startsWith(query)) {
        if (airport.iatA_CODE.toLowerCase() === query) {
          filtered[0] = airport.airportName;
        }
        filtered.push(airport.airportName);
      }
    }
    filtered = [...new Set(filtered)];
    this.filteredAirports = filtered;
  }


  flightSearchPop() {
    var flightSearchDiv = document.querySelector(".search_flight_sect") as HTMLDivElement;
    flightSearchDiv.style.display = "block";
    var importPNRDiv = document.querySelector(".pnr-popup") as HTMLDivElement;
    importPNRDiv.classList.add("fhid");
    var section2Div = document.querySelector(".section2") as HTMLDivElement;
    section2Div.style.display = "inline-block";
    var flightSTab = document.querySelector(".flight_s_tab") as HTMLDivElement;
    flightSTab.classList.add("active");
    var pnrTab = document.querySelector(".import_pnr_tab") as HTMLDivElement;
    pnrTab.classList.remove("active");
  }

  pnrPopUp() {
    if (this.IMPORTRights) {
      var importPNRDiv = document.querySelector(".pnr-popup") as HTMLDivElement;
      importPNRDiv.classList.remove("fhid");
      var flightSearchDiv = document.querySelector(".search_flight_sect") as HTMLDivElement;
      flightSearchDiv.style.display = "none";
      var section2Div = document.querySelector(".section2") as HTMLDivElement;
      section2Div.style.display = "none";
      var pnrTab = document.querySelector(".import_pnr_tab") as HTMLDivElement;
      pnrTab.classList.add("active");
      var flightSTab = document.querySelector(".flight_s_tab") as HTMLDivElement;
      flightSTab.classList.remove("active");
    }
  }

  GroupTicketForUser() {

    //localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
    this.router.navigateByUrl('/groupTicketForUserNew');

  }
  /******************** Notification POP UP ****************************************/
  activeNotification: NotificationProperties[] = [];
  getActiveNotification() {
    this.cmsService.getActiveNotification().subscribe((data) => {
      this.activeNotification = data;
    })
  }

  /******************** News ****************************************/
  activeNews: NewsAlertProperties[] = [];
  getActiveNews() {
    if (this.isAG01) {
      this.cmsService.getActiveNews().subscribe((data) => {
        //if()
        this.activeNews = data;
      })
    }
  }

  notiPop() {
    if (this.isAG01) {
      this.cmsService.getActiveNotification().subscribe((data) => {

        this.activeNotification = data;
        this.primeShowModal = true;
      });
    }
    this.cmsService.GetGroupTicketRight().subscribe(data => {
      this.groupTicketShowRightCMS = data;

    })
  }
  PrimeCloseModal = (): void => {
    this.primeShowModal = false;
  }
  AddPassengerList() {
    for (let i = 0; i <= 8; i++) {
      let childItme = new Number();
      childItme = Number(i);
      this.childList.push(childItme);
    }
    for (let i = 0; i <= 1; i++) {
      let infantItem = new Number();
      infantItem = Number(i);
      this.infantList.push(infantItem);
    }
  }

  AddDefaultFlights() {
    try {
      for (let i = 0; i <= 1; i++) {
        let obj = new FlightSearchDestinationProperties();

        this.defaultMulticityDiv.push(obj);

      }
    }
    catch (e) {

    }
  }

  GetSearchBaseData() {
    try {
      this.flightService.CheckFlightSearchScreenRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data1) => {
        this.haveRights = data1;
        this.flightService.GetFlightBaseData().subscribe((data) => {
          this.allBaseData$ = this.activatedRoute.snapshot.data.flightSearch;
          /* this.originalAirlines = this.allBaseData$.airlines;*/
          this.airlineList$ = of(this.allBaseData$.airlines);
          this.airLineData = this.allBaseData$.airlines;

          this.airportList = this.allBaseData$.airports;

          this.flightService.GetAllImportPnrEntry().subscribe((oficeIdData) => {
            this.importPnrEntryList$ = oficeIdData;
          });
          this.flightService.GetGetAllBookingPCCs(this.supplierId).subscribe((oficeIdData) => {
            this.pccList$ = of(oficeIdData);
          });
          this.dataSource = new DataSource({
            store: new ArrayStore({
              data: this.airportList,
              key: "airportName"
            }),
            group: "cityCountry",

          });
          this.flightService.CheckImportRights(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data2) => {
            this.IMPORTRights = data2;
          });
          this.dataSource.load();
          //if (this.allBaseData$.airports.length > 0) {
          //for (let i = 0; i < this.allBaseData$.airports.length; i++) {
          //this.airportData.push(this.allBaseData$.airports[i].cityName);
          //this.multiwayFrom = this.allBaseData$.airports[i].cityName;
          //}
         
          //}
        })
      })
    }
    catch (e) {

    }
  }
  airportDATAList: FlightSearchAirports[] = [];
  city: string = "";
  filterDataSource(e) {
    //if (e.component._changedValue != null || e.component._changedValue != "" || e.component._changedValue == undefined)
    //if (e.component._changedValue.length >= 3) {
    for (let n = 0; n < this.airportList.length; n++) {
      if (this.airportList[n].iatA_CODE == e.component._changedValue) {


      }
    }
    for (let p = 1; p < this.airportList.length; p++) {
      if (this.city == this.airportList[p].city) {
        this.airportDATAList.push(this.airportList[p])
      }
    }
    //console.log(this.airportDATAList);
    //}
  }
  RoundtripDepartingDateChange(rdValue: any) {
    let datePipe: DatePipe = new DatePipe('en-US');

    // Check if rdValue is a valid date
    let date = new Date(rdValue);
    if (date instanceof Date && !isNaN(date.getTime())) {
      this.roundTripDeparture = datePipe.transform(date, 'yyyy-MM-dd');
    }
  }
  ChangeFlightTrip(tripValue) {
    try {
      if (tripValue == "oneway") {
        $("#oneWayDiv").show();
        $("#roundTripDiv").hide();
        $("#multiCityDiv").hide();
        $("#airlineOnewayTab").show();
        $("#airlineRoundtripTab").hide();
        $("#airlineMulticityTab").hide();
        this.isOneway = true;
        this.isRoundtrip = false;
        this.isMulticity = false;
        $("#addFlightbtn").hide();
        this.searchObj.tripType = tripValue;
        this.migrateDataBack();

      }
      else if (tripValue == "roundtrip") {

        $("#oneWayDiv").hide();
        $("#roundTripDiv").show();
        $("#multiCityDiv").hide();
        $("#airlineOnewayTab").hide();
        $("#airlineRoundtripTab").show();
        $("#airlineMulticityTab").hide();
        this.isOneway = false;
        this.isRoundtrip = true;
        this.isMulticity = false;
        $("#addFlightbtn").hide();
        this.searchObj.tripType = tripValue;
        this.migrateData();

      }
      else if (tripValue == "multicity") {
        $("#oneWayDiv").hide();
        $("#roundTripDiv").hide();
        $("#multiCityDiv").show();
        $("#airlineOnewayTab").hide();
        $("#airlineRoundtripTab").hide();
        $("#airlineMulticityTab").show();
        this.isOneway = false;
        this.isRoundtrip = false;
        this.isMulticity = true;
        $("#addFlightbtn").show();
        this.searchObj.tripType = tripValue;
      }
    }
    catch (e) {

    }
  }



  ChangeOnewayFrom(value) {
    try {
      if (value != "" && value != null) {
        /* <HTMLInputElement><unknown>document.getElementById('tbOnewayFrom').focus();*/
        this.tbOnewayToAuto.instance.focus();
      }
    }
    catch (e) { }
  }

  ChangeOnewayTo(value) {
    try {
      if (value != "" && value != null) {
        document.getElementById("tbOnewayDeparture").focus();
        document.getElementById("tbOnewayDeparture").click();
      }
    }
    catch (e) { }
  }

  ChangeRoundTripFrom(value) {
    try {
      if (value != "" && value != null) {
        /* <HTMLInputElement><unknown>document.getElementById('tbOnewayFrom').focus();*/
        this.roundTripToAuto.instance.focus();
      }
    }
    catch (e) { }
  }

  ChangeRoundTripTo(event) {
    try {
      this.tbRoundTripDepartingDate.nativeElement.focus();
      this.tbRoundTripDepartingDate.nativeElement.click();
      //if (value != "" && value != null) {
      //  document.getElementById("tbRoundtripDate").focus();
      //  document.getElementById("tbRoundtripDate").click();
      //}
    }
    catch (e) { }
  }

  ChangemulticityFrom(value) {
    try {
      //if (value != "" && value != null) {
      //  /* <HTMLInputElement><unknown>document.getElementById('tbOnewayFrom').focus();*/
      //  this.multicityToAuto.instance.focus();
      //}
    }
    catch (e) { }
  }

  ChangemulticityTo(value) {
    try {

      //if (value != "" && value != null) {
      //  document.getElementById("tbMulticityDeparture").focus();
      //  document.getElementById("tbMulticityDeparture").click();
      //}


    }
    catch (e) { }
  }
  GetAllGroupTicket = (): void => {
    this.ticketService.GetAllGroupTicket(this.groupTicketSearch).subscribe(
      response => {
        console.log(response)
        if (response.status) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          // const agencyId = localStorage.getItem("AgencyId");

          // Fetch the group ticketShowRight
          this.flightService.GetAgencyAndUserGroupTicketRigts(localStorage.getItem("UserId"), localStorage.getItem("AgencyId"))
            .subscribe(data => {
              this.flightSearchRightsObj = data;
              localStorage.setItem("flightSearchRightsObj", JSON.stringify(this.flightSearchRightsObj));
              console.log(this.flightSearchRightsObj)

              const groupTicketViewRight = this.flightSearchRightsObj.agencyGroupTicketSearch && this.flightSearchRightsObj.userGroupTicketSearch;


              // Process the tickets after fetching the agency details
              this.groupTicketList = response.responseData
                .filter(ticket => {
                  const ticketExpirationDate = new Date(ticket.ticketExpiryDate);
                  ticketExpirationDate.setHours(0, 0, 0, 0);

                  const isNotExpired = ticketExpirationDate >= today;
                  console.log(isNotExpired, groupTicketViewRight)
                  return isNotExpired && groupTicketViewRight; // Adjust the right check as needed
                })
                .map(ticket => ({
                  ...ticket,
                  tripRoute: `${ticket.onewayFromAirport}--${ticket.onewayToAirport}`
                }));
            },
              error => {
                console.error('Error fetching agency details:', error);
              }
            );
        }
      },
      error => {
        console.error('Error fetching group tickets:', error);
      }
    );
  }

  ChangeOnewayAdult(value: number) {
    try {
      let count = 9 - value;
      if (count >= 0) {
        this.childList = [];
        if ((value + this.onewaySearchObj.child) > 9) {
          this.onewaySearchObj.child = this.childList.length;
          this.ChangeOnewayChildAge(this.onewaySearchObj.child);
        };
        for (let i = 0; i <= count; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }


      }
      else {
        for (let i = 0; i <= 9; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }

      if (value > 0) {
        this.infantList = [];
        this.onewaySearchObj.infant = 0;
        for (let i = 0; i < value + 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
        this.ChangeOnewayInfantAge(this.onewaySearchObj.infant);
      }
      else if (value == null || value == undefined) {
        this.onewaySearchObj.infant = 0;
        this.infantList = [0];
        this.ChangeOnewayInfantAge(this.onewaySearchObj.infant);
      }

      else {
        for (let i = 0; i <= 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
      }
    }
    catch (e) {
    }
  }


  ChangeRoundtripAdult(value: number) {
    try {
      let count = 9 - value;
      if (count >= 0) {
        this.childList = [];
        if ((value + this.roundtripSearchObj.child) > 9) {
          this.roundtripSearchObj.child = this.childList.length;
          this.ChangeRoundwayChildAge(this.roundtripSearchObj.child);
        };

        for (let i = 0; i <= count; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }
      else {
        for (let i = 0; i <= 9; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }
      if (value > 0) {
        this.infantList = [];
        this.roundtripSearchObj.infant = 0;
        for (let i = 0; i < value + 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
        this.ChangeRoundwayInfantAge(this.roundtripSearchObj.infant);
      }
      else if (value == null || value == undefined) {
        this.roundtripSearchObj.infant = 0;
        this.infantList = [0];
        this.ChangeRoundwayInfantAge(this.roundtripSearchObj.infant);
      }
      else {
        for (let i = 0; i <= 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
      }
    }
    catch (e) {
    }
  }


  ChangeMultiCityAdult(value: number) {
    try {
      let count = 9 - value;
      if (count >= 0) {
        this.childList = [];
        if ((value + this.multiCitySearchObj.child) > 9) {
          this.multiCitySearchObj.child = this.childList.length;
          this.ChangeMulticityChildAge(this.multiCitySearchObj.child);
        };

        for (let i = 0; i <= count; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }
      else {
        for (let i = 0; i <= 9; i++) {
          let childItme = new Number();
          childItme = Number(i);
          this.childList.push(childItme);
        }
      }
      if (value > 0) {
        this.infantList = [];
        this.multiCitySearchObj.infant = 0;
        for (let i = 0; i < value + 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
        this.ChangeMulticityInfantAge(this.multiCitySearchObj.infant);
      }
      else if (value == null || value == undefined) {
        this.multiCitySearchObj.infant = 0;
        this.infantList = [0];
        this.ChangeMulticityInfantAge(this.multiCitySearchObj.infant);
      }
      else {
        for (let i = 0; i <= 1; i++) {
          let infantItem = new Number();
          infantItem = Number(i);
          this.infantList.push(infantItem);
        }
      }
    }
    catch (e) {
    }
  }
  ////
  //AddNewFlight() {

  //  let obj = new FlightSearchDestinationProperties();
  //  if ((this.defaultMulticityDiv[0].fromAirport != "" && this.defaultMulticityDiv[0].toAirport != "" && this.defaultMulticityDiv[0].departureDate != "")
  //    && (this.defaultMulticityDiv[1].fromAirport != "" && this.defaultMulticityDiv[1].toAirport != "" && this.defaultMulticityDiv[1].departureDate != "")) {
  //    if ((this.defaultMulticityDiv[1].departureDate >= this.defaultMulticityDiv[0].departureDate)) {
  //      this.defaultMulticityDiv.push(obj)
  //    }
  //    else {
  //      document.getElementById("lblError3").style.display = "block";
  //      document.getElementById("lblError3").innerHTML = "Second Sector Date Should be Greater Than First Sector";
  //      setTimeout(() => {
  //        document.getElementById("lblError3").style.display = "none";
  //        document.getElementById("lblError3").innerHTML = "";
  //      }, 8000)
  //    }

  //  }
  //  else {
  //    document.getElementById("lblError3").style.display = "block";
  //    document.getElementById("lblError3").innerHTML = "Please Fill given Sectors First";
  //    setTimeout(() => {
  //      document.getElementById("lblError3").style.display = "none";
  //      document.getElementById("lblError3").innerHTML = "";
  //    }, 8000)


  //  }

  //  //console.log(this.defaultMulticityDiv);
  //  //this.multiwayFrom = obj.fromAirport;
  //  //console.log(this.multiwayFrom)

  //  if (this.defaultMulticityDiv.length == 6)
  //    $("#addFlightbtn").hide();

  //}
  //end

  RemoveFlight(index: number) {
    try {
      this.defaultMulticityDiv.splice(index, 1);
      console.log(this.defaultMulticityDiv);
      if (this.defaultMulticityDiv.length < 6) {
        $("#addFlightbtn").show();
      }
      else {
        $("#addFlightbtn").hide();
      }
    }
    catch (e) { }
  }

  OnewayDateChange(value) {
    let arrivePipe: DatePipe = new DatePipe('en-US');
    this.onewayDeparture = arrivePipe.transform(value, "yyyy-MM-dd");

    //this.onewayDeparture = value.toISOString().split('T')[0];
  }

  //onDatepickerShown() {
  //  const datePickerInstance: BsDaterangepickerContainerComponent = this.dateRangePicker['_datepicker'].instance;
  //  datePickerInstance.valueChange
  //    .pipe(
  //      filter(value => value && value[0] && !value[1])
  //    )
  //    .subscribe((value: Date[]) => {
  //      const [startDate] = value;
  //      console.log(startDate);
  //    });
  //}




  addDaysToReturning(e) {
    let days = Number(e.target.value);
    let dateDepartLong: Date = new Date(this.roundTripDeparture);
    dateDepartLong.setDate(dateDepartLong.getDate() + days);
    dateDepartLong.setHours(0);
    dateDepartLong.setMinutes(0);
    dateDepartLong.setSeconds(0);
    dateDepartLong.setMilliseconds(0);
    let datePipe: DatePipe = new DatePipe('en-US');
    this.roundtripSearchObj.returnDate = (datePipe.transform(dateDepartLong, "dd/MM/yyyy"));
  }
  RoundtripReturningDateChange(rrValue: Date) {
    //this.roundtripSearchObj.returnDate = rrValue.toISOString().split('T')[0];
    let arrivePipe: DatePipe = new DatePipe('en-US');
    this.roundtripSearchObj.returnDate = arrivePipe.transform(rrValue, "dd/MM/yyyy");
    this.cd.detectChanges();
  }


  ////s..............
  //multicityDateChange(value: string, j) {

  //  let abc = [];
  //  if (value == undefined) {
  //    return
  //  }
  //  this.multiCityDeparture = value;
  //  console.log(this.datess[j]);
  //  if (this.datess[j]) {
  //    this.datess.splice(j, 1, this.multiCityDeparture)
  //  } else {
  //    this.datess.splice(j, 0, this.multiCityDeparture)
  //  }
  //  this.datess = this.datess.concat(this.multiCityDeparture);
  //  this.datess = this.datess.filter(function (element) {
  //    return element !== undefined;
  //  });
  //  if (this.datess.length === 1) {
  //    this.muldestinationObj.departureDate = this.datess[0];
  //  }
  //  if (this.datess.length > 1) {
  //    for (let i = 0; i < this.datess.length - 1; i++) {
  //      if (this.datess[i] > this.datess[i + 1]) {
  //        (<HTMLInputElement>document.querySelector(".message")).style.display = "inline-block";
  //        (<HTMLInputElement>document.querySelector(".da1"+j)).value = "";
  //        document.querySelector(".message").textContent = "later date must be greater than previous date";
  //        this.defaultMulticityDiv[j].departureDate = "";
  //        let removDate = document.querySelector("#tbMulticityDeparture" + j) as HTMLInputElement;
  //        removDate.style.border = "1px solid red";
  //        removDate.textContent = this.defaultMulticityDiv[j].departureDate;
  //        let btndisable = document.querySelector("#multiSearchClick") as HTMLButtonElement;
  //        btndisable.disabled = true;
  //         $("#multiSearchClick").hide();
  //        setTimeout(function () {
  //          (<HTMLInputElement>document.querySelector(".da1" + j)).value = "";
  //          (<HTMLInputElement>document.querySelector(".message")).style.display = "none";
  //          this.defaultMulticityDiv[j].departureDate = "";
  //          let removDate = document.querySelector("#tbMulticityDeparture" + j) as HTMLInputElement;
  //          removDate.style.border = "1px solid black";
  //           removDate.value = this.defaultMulticityDiv[j].departureDate;

  //        }, 4000)
  //      } else {
  //        this.muldestinationObj.departureDate = this.datess[i + 1];
  //        let removDate = document.querySelector("#tbMulticityDeparture" + j) as HTMLInputElement;
  //        removDate.style.border = "1px solid black";
  //        $("#multiSearchClick").show();
  //        let btndisable = document.querySelector("#multiSearchClick") as HTMLButtonElement;
  //        btndisable.disabled = false;
  //      }
  //    }
  //    console.log(this.muldestinationObj.departureDate)

  //  }


  //}
  multicityIndex = 0;
  multicityValue: string = "";
  //multicityDateChange(value, i) {
  //  if (value != undefined) {
  //    if (i == 0) {
  //      this.multicityIndex = 0;
  //      this.multicityValue = value;
  //    }
  //    if ((i > this.multicityIndex) && (value < this.multicityValue && this.multicityValue != "")) {
  //      (<HTMLInputElement>document.querySelector(".message")).style.display = "inline-block";
  //      document.querySelector(".message").textContent = "later date must be greater than previous date";
  //      let removDate = document.querySelector("#tbMulticityDeparture" + i) as HTMLInputElement;
  //      removDate.style.border = "1px solid red";
  //      document.getElementById("multiSearchClick").setAttribute("disabled", "disabled");
  //    }
  //    else {
  //      if ((i > this.multicityIndex) && (value >= this.multicityValue && this.multicityValue != "")) {
  //        this.multicityIndex = i;
  //        this.multicityValue = value;
  //        (<HTMLInputElement>document.querySelector(".message")).style.display = "none";
  //        document.querySelector(".message").textContent = "";
  //        let removDate = document.querySelector("#tbMulticityDeparture" + i) as HTMLInputElement;
  //        removDate.style.border = "";
  //        document.getElementById("multiSearchClick").removeAttribute("disabled");

  //      }
  //    }

  //  }


  //}
  //end........
  childAgeListOf: ChildAgeProps[] = [];
  infantAgeListOf: InfantAgeProps[] = [];
  childAgeItem: number = 0;
  childAgeValue: number;
  infantAgeValue: string;
  ChangeOnewayChildAge(value: number) {
    try {
      if (value != 0) {

        //this.infantList = [];
        //if ((this.onewaySearchObj.adult + value + this.onewaySearchObj.infant) > 9) {
        //  this.onewaySearchObj.infant = this.infantList.length;
        //  this.ChangeOnewayInfantAge(this.onewaySearchObj.infant);
        //};
        //for (let i = 0; i <= 9 - (this.onewaySearchObj.adult + value) && i <= this.onewaySearchObj.adult; i++) {
        //  let infantItme = new Number();
        //  infantItme = Number(i);
        //  this.infantList.push(infantItme);
        //}


        this.childAgeListOf.splice(0, this.childAgeListOf.length);
        for (let p = 0; p < value; p++) {
          this.childAgeObj = new ChildAgeProps();
          this.childAgeObj.childAge = this.childAgeValue;
          this.childAgeListOf.push(this.childAgeObj);
        }
        var chAgeCont = document.querySelector(".child_age_container") as HTMLDivElement;
        chAgeCont.style.display = "flex";
      }
      else {
        var chAgeCont = document.querySelector(".child_age_container") as HTMLDivElement;
        chAgeCont.style.display = "none";
        this.childAgeListOf.splice(0, this.childAgeListOf.length);
      }

    }
    catch (ex) {
      console.log(ex);
    }

  }


  ChangeOnewayInfantAge(infValue: number) {
    try {
      if (infValue != 0) {

        //this.childList = [];
        //for (let i = 0; i <= 9 - (this.onewaySearchObj.adult + this.onewaySearchObj.infant); i++) {
        //  let childItem = new Number();
        //  childItem = Number(i);
        //  this.childList.push(childItem);
        //}


        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
        for (let p = 0; p < infValue; p++) {
          this.infantAgeObj = new InfantAgeProps();
          this.infantAgeObj.infantAge = this.infantAgeValue;
          this.infantAgeListOf.push(this.infantAgeObj);
        }
        var inAgeCont = document.querySelector(".infant_age_container") as HTMLDivElement;
        inAgeCont.style.display = "flex";
      }
      else {
        var inAgeContNo = document.querySelector(".infant_age_container") as HTMLDivElement;
        inAgeContNo.style.display = "none";
        this.infantAgeListOf.splice(0, this.infantAgeListOf.length);
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }
  //OnewaySearchClick() {
  //  try {
  //    if (this.OnewayValidation()) {
  //      //26-july-23
  //      if (this.onewaySearchObj.prefferedAirline1 != "" || this.onewaySearchObj.prefferedAirline2 != "" || this.onewaySearchObj.prefferedAirline3 != "") {
  //        if (this.onewaySearchObj.prefferedAirline1 == this.onewaySearchObj.prefferedAirline2
  //          && this.onewaySearchObj.prefferedAirline1 != "" && this.onewaySearchObj.prefferedAirline2 != ""
  //          && this.onewaySearchObj.prefferedAirline1 != null && this.onewaySearchObj.prefferedAirline2 != null
  //          && this.onewaySearchObj.prefferedAirline1 != undefined && this.onewaySearchObj.prefferedAirline2 != undefined) {
  //          $("#lblError1").show();
  //          document.getElementById("lblError1").style.color = "#FE2C02";
  //          document.getElementById("lblError1").innerHTML = "You Cannot Select Same Preffed Airlines"
  //          $("#lblError1").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.onewaySearchObj.prefferedAirline1 == this.onewaySearchObj.prefferedAirline3
  //          && this.onewaySearchObj.prefferedAirline1 != "" && this.onewaySearchObj.prefferedAirline3 != ""
  //          && this.onewaySearchObj.prefferedAirline1 != null && this.onewaySearchObj.prefferedAirline3 != null
  //          && this.onewaySearchObj.prefferedAirline1 != undefined && this.onewaySearchObj.prefferedAirline3 != undefined) {
  //          $("#lblError1").show();
  //          document.getElementById("lblError1").style.color = "#FE2C02";
  //          document.getElementById("lblError1").innerHTML = "You Cannot Select Same Preffed Airlines"
  //          $("#lblError1").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.onewaySearchObj.prefferedAirline2 == this.onewaySearchObj.prefferedAirline3
  //          && this.onewaySearchObj.prefferedAirline2 != "" && this.onewaySearchObj.prefferedAirline3 != ""
  //          && this.onewaySearchObj.prefferedAirline2 != null && this.onewaySearchObj.prefferedAirline3 != null
  //          && this.onewaySearchObj.prefferedAirline2 != undefined && this.onewaySearchObj.prefferedAirline3 != undefined) {
  //          $("#lblError1").show();
  //          document.getElementById("lblError1").style.color = "#FE2C02";
  //          document.getElementById("lblError1").innerHTML = "You Cannot Select Same Preffed Airlines"
  //          $("#lblError1").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.onewaySearchObj.prefferedAirline1 == null) {
  //          this.onewaySearchObj.prefferedAirline1 = "";
  //        }
  //        if (this.onewaySearchObj.prefferedAirline2 == null) {
  //          this.onewaySearchObj.prefferedAirline2 = "";
  //        }
  //        if (this.onewaySearchObj.prefferedAirline3 == null) {
  //          this.onewaySearchObj.prefferedAirline3 = "";
  //        }
  //      }
  //      //end
  //      document.getElementById("lblError1").style.display = "none";

  //      if (this.haveRights) {
  //        this.searchObj = new FlightSearchProperties();
  //        this.searchObj.agencyID = localStorage.getItem("AgencyId");
  //        this.searchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
  //        this.searchObj.adult = this.onewaySearchObj.adult;
  //        this.searchObj.infant = this.onewaySearchObj.infant;
  //        this.searchObj.child = this.onewaySearchObj.child;
  //        this.searchObj.fareType = this.onewaySearchObj.fareType;
  //        this.searchObj.cabinClass = this.onewaySearchObj.cabinClass;
  //        this.searchObj.departureTime = this.onewaySearchObj.departureTime;
  //        this.searchObj.nonStopFlight = this.onewaySearchObj.nonStopFlight;
  //        this.searchObj.nearByAirport = this.onewaySearchObj.nearByAirport;
  //        this.searchObj.lowCostAirline = this.onewaySearchObj.lowCostAirline;
  //        this.searchObj.gdsAirline = this.onewaySearchObj.gdsAirline;
  //        this.searchObj.prefferedAirline1 = this.onewaySearchObj.prefferedAirline1
  //        this.searchObj.prefferedAirline2 = this.onewaySearchObj.prefferedAirline2;
  //        this.searchObj.prefferedAirline3 = this.onewaySearchObj.prefferedAirline3;
  //        if (this.onewaySearchObj.adult == null) {
  //          this.searchObj.adult = 0;
  //        }
  //        if (this.onewaySearchObj.infant == null) {
  //          this.searchObj.infant = 0;
  //        }
  //        if (this.onewaySearchObj.child == null) {
  //          this.searchObj.child = 0;
  //        }
  //        for (let n = 0; n < this.childAgeListOf.length; n++) {
  //          this.searchObj.childAges.push(String(this.childAgeListOf[n].childAge));
  //        }
  //        for (let q = 0; q < this.infantAgeListOf.length; q++) {
  //          this.searchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
  //          if (this.searchObj.infantAges[q] == "less than 1") {
  //            this.searchObj.infantAges[q] = "0";
  //          }
  //          else if (this.onewaySearchObj.infant == 0) {
  //            this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);
  //          }
  //        }
  //        for (let p = 0; p < this.searchObj.childAges.length; p++) {

  //          if (this.searchObj.child > 0 && this.searchObj.childAges[p].includes("undefined")) {

  //            $("#lblError1").show();

  //            document.getElementById("lblError1").style.color = "#FE2C02";

  //            document.getElementById("lblError1").innerHTML = "Please select ages for Child(ren).";

  //            $("#lblError1").delay(5000).hide(100);

  //            return false;

  //          }

  //        }

  //        for (let q = 0; q < this.searchObj.infantAges.length; q++) {

  //          if (this.searchObj.infant > 0 && this.searchObj.infantAges[q].includes("undefined")) {

  //            $("#lblError1").show();

  //            document.getElementById("lblError1").style.color = "#FE2C02";

  //            document.getElementById("lblError1").innerHTML = "Please select ages for Infant(s).";

  //            $("#lblError1").delay(5000).hide(100);

  //            return false;

  //          }


  //        }

  //        this.searchObj.tripType = "single-round";
  //        // let obj = new FlightSearchDestinationProperties();
  //        let start = this.onewayFrom.indexOf(this.onewayFrom[0]);
  //        let end = this.onewayFrom.indexOf('-');
  //        this.onewayFcity = this.onewayFrom.slice(start, end);
  //        this.destinationObj.fromAirport = this.onewayFrom;
  //        let start1 = this.onewayTo.indexOf(this.onewayTo[0]);
  //        let end1 = this.onewayTo.indexOf('-');
  //        this.onewayTcity = this.onewayTo.slice(start, end);
  //        this.destinationObj.toAirport = this.onewayTo;
  //        this.destinationObj.fromCity = this.onewayFcity;
  //        this.destinationObj.toCity = this.onewayTcity;
  //        this.destinationObj.departureDate = this.onewayDeparture;
  //        //19-july-23


  //        for (let i = 0; i < this.airportList.length; i++) {

  //          if (this.onewayFcity.trim() == this.airportList[i].iatA_CODE) {
  //            this.destinationObj.combineAirportFrom = this.airportList[i].combineAirportFrom;
  //            break;
  //          }

  //        }
  //        for (let i = 0; i < this.airportList.length; i++) {
  //          if (this.onewayTcity.trim() == this.airportList[i].iatA_CODE) {
  //            this.destinationObj.combineAirportTo = this.airportList[i].combineAirportTo;

  //            break;
  //          }

  //        }

  //        //end
  //        this.searchObj.flightLocationInfo.push(this.destinationObj);

  //        // History
  //        //let searchHistoryObj = new FlightSearchHistory();
  //        //searchHistoryObj.agencyId = localStorage.getItem("AgencyId");
  //        //searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
  //        //searchHistoryObj.fromAirport = this.destinationObj.fromAirport;
  //        //searchHistoryObj.toAirport = this.destinationObj.toAirport;
  //        //searchHistoryObj.fromCity = this.destinationObj.fromCity;
  //        //searchHistoryObj.toCity = this.destinationObj.toCity;
  //        //searchHistoryObj.departureDate = this.destinationObj.departureDate;
  //        //searchHistoryObj.tripType = "Oneway";
  //        //searchHistoryObj.travelClass = this.searchObj.cabinClass;
  //        //searchHistoryObj.fareType = this.searchObj.fareType;
  //        //searchHistoryObj.isNonStop = this.searchObj.nonStopFlight;
  //        //searchHistoryObj.isLowCost = this.searchObj.lowCostAirline;
  //        //searchHistoryObj.isGDSAirline = this.searchObj.gdsAirline;
  //        //searchHistoryObj.adults = this.searchObj.adult;
  //        //searchHistoryObj.children = this.searchObj.child;
  //        //searchHistoryObj.infants = this.searchObj.infant;
  //        //searchHistoryObj.returnDate = "N/A";
  //        //searchHistoryObj.fromAirportReturn = "N/A";
  //        //searchHistoryObj.toAirportReturn = "N/A";
  //        //searchHistoryObj.fromCityReturn = "N/A";
  //        //searchHistoryObj.toCityReturn = "N/A";
  //        //this.addFlightSearchHistory(searchHistoryObj);
  //        this.searchObj.journeyType = 1;
  //        localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));
  //        this.router.navigateByUrl('/flightResults');
  //      }
  //      else {
  //        $("#lblError1").show();
  //        document.getElementById("lblError1").style.color = "#FE2C02";
  //        document.getElementById("lblError1").innerHTML = "You don't have right to perform search."
  //        $("#lblError1").delay(5000).hide(100);
  //        return false;
  //      }

  //    }
  //    else {
  //      document.getElementById("lblError1").style.display = "block";
  //      setTimeout(() => {
  //        document.getElementById("lblError1").style.display = "none";
  //      }, 6000)
  //    }

  //  }
  //  catch (e) {

  //  }
  //}
  //end

  migrateData() {

    let start = this.onewayFrom.indexOf(this.onewayFrom[0]);
    let end = this.onewayFrom.indexOf('-');
    this.onewayFcity = this.onewayFrom.slice(start, end);
    this.destinationObj.fromAirport = this.onewayFrom;
    let start1 = this.onewayTo.indexOf(this.onewayTo[0]);
    let end1 = this.onewayTo.indexOf('-');
    this.onewayTcity = this.onewayTo.slice(start, end);
    this.destinationObj.toAirport = this.onewayTo;
    this.destinationObj.fromCity = this.onewayFcity;
    this.destinationObj.toCity = this.onewayTcity;
    this.destinationObj.departureDate = this.onewayDeparture;

    for (let n = 0; n < this.childAgeListOf.length; n++) {
      this.searchObj.childAges.push(String(this.childAgeListOf[n].childAge));
    }
    for (let q = 0; q < this.infantAgeListOf.length; q++) {
      this.searchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
      if (this.searchObj.infantAges[q] == "less than 1") {
        this.searchObj.infantAges[q] = "0";
      }
      else if (this.onewaySearchObj.infant == 0) {
        this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);
      }
    }

    this.roundTripFrom = this.onewayFrom;
    this.roundTripTo = this.onewayTo;
    if (this.onewayDeparture == "" || this.onewayDeparture == null || this.onewayDeparture == undefined) {
      this.roundtripSearchObj.departureTime = "";
    } else {
      let dateDepartLong: Date = new Date(this.onewayDeparture);
      dateDepartLong.setHours(0);
      dateDepartLong.setMinutes(0);
      dateDepartLong.setSeconds(0);
      dateDepartLong.setMilliseconds(0);
      let datePipe: DatePipe = new DatePipe('en-US');
      this.roundtripSearchObj.departureTime = (datePipe.transform(dateDepartLong, "dd/MM/yyyy"));
    }
    //this.roundtripSearchObj.departureTime = this.onewayDeparture;
    this.roundtripSearchObj.adult = this.onewaySearchObj.adult;
    this.roundtripSearchObj.child = this.onewaySearchObj.child;
    this.roundtripSearchObj.infant = this.onewaySearchObj.infant;
    this.roundtripSearchObj.cabinClass = this.onewaySearchObj.cabinClass;
    this.roundtripSearchObj.fareType = this.onewaySearchObj.fareType;
    this.ChangeRoundwayChildAge(this.roundtripSearchObj.child);
    this.ChangeRoundwayInfantAge(this.roundtripSearchObj.infant);

    for (let k = 0; k < this.childAgeListOf.length; k++) {
      this.childAgeListOfR[k].childAge = this.childAgeListOf[k].childAge;
    }
    for (let l = 0; l < this.infantAgeListOf.length; l++) {
      this.infantAgeListOfR[l].infantAge = this.infantAgeListOf[l].infantAge;
    }
  }


  migrateDataBack() {

    let start = this.roundTripFrom.indexOf(this.roundTripFrom[0]);
    let end = this.roundTripFrom.indexOf('-');
    this.roundwayFcity = this.roundTripFrom.slice(start, end);
    this.destinationObj.fromAirport = this.roundTripFrom;

    let start1 = this.roundTripTo.indexOf(this.roundTripTo[0]);
    let end2 = this.roundTripTo.indexOf('-');
    this.roundwayTcity = this.roundTripTo.slice(start, end);
    this.destinationObj.toAirport = this.roundTripTo;

    this.destinationObj.fromCity = this.roundwayFcity;
    this.destinationObj.toCity = this.roundwayTcity;
    this.destinationObj.departureDate = this.roundTripDeparture;

    for (let n = 0; n < this.childAgeListOfR.length; n++) {
      this.searchObj.childAges.push(String(this.childAgeListOfR[n].childAge));
    }

    for (let q = 0; q < this.infantAgeListOfR.length; q++) {
      this.searchObj.infantAges.push(this.infantAgeListOfR[q].infantAge);
      if (this.searchObj.infantAges[q] == "less than 1") {
        this.searchObj.infantAges[q] = "0";
      }
      else if (this.roundtripSearchObj.infant == 0) {
        this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);
      }
    }

    this.onewayFrom = this.roundTripFrom;
    this.onewayTo = this.roundTripTo;
    if (this.roundTripDeparture == "" || this.roundTripDeparture == null || this.roundTripDeparture == undefined) {
      this.onewayDepartureDate = "";
    } else {
      let dateDepartLong: Date = new Date(this.roundTripDeparture);
      dateDepartLong.setHours(0);
      dateDepartLong.setMinutes(0);
      dateDepartLong.setSeconds(0);
      dateDepartLong.setMilliseconds(0);
      let datePipe: DatePipe = new DatePipe('en-US');
      this.onewayDepartureDate = (datePipe.transform(dateDepartLong, "dd/MM/yyyy"));
    }
    //this.onewayDepartureDate = this.roundTripDeparture;
    this.onewaySearchObj.adult = this.roundtripSearchObj.adult;
    this.onewaySearchObj.child = this.roundtripSearchObj.child;
    this.onewaySearchObj.infant = this.roundtripSearchObj.infant;
    this.onewaySearchObj.cabinClass = this.roundtripSearchObj.cabinClass;
    this.onewaySearchObj.fareType = this.roundtripSearchObj.fareType;
    this.ChangeOnewayChildAge(this.onewaySearchObj.child);
    this.ChangeOnewayInfantAge(this.onewaySearchObj.infant);

    for (let k = 0; k < this.childAgeListOfR.length; k++) {
      this.childAgeListOf[k].childAge = this.childAgeListOfR[k].childAge;
    }
    for (let l = 0; l < this.infantAgeListOfR.length; l++) {
      this.infantAgeListOf[l].infantAge = this.infantAgeListOfR[l].infantAge;
    }
  }


  childAgeListOfR: ChildAgeProps[] = [];
  infantAgeListOfR: InfantAgeProps[] = [];
  childAgeItemR: number = 0;
  childAgeValueR: number;
  infantAgeValueR: string;
  ChangeRoundwayChildAge(rValue) {
    try {
      if (rValue != 0) {

        //this.infantList = [];
        //if ((this.roundtripSearchObj.adult + rValue + this.roundtripSearchObj.infant) > 9) {
        //  this.roundtripSearchObj.infant = this.infantList.length;
        //  this.ChangeRoundwayInfantAge(this.roundtripSearchObj.infant);
        //};

        //for (let i = 0; i <= 9 - (this.roundtripSearchObj.adult + rValue) && i <= this.roundtripSearchObj.adult; i++) {
        //  let infantItmeR = new Number();
        //  infantItmeR = Number(i);
        //  this.infantList.push(infantItmeR);
        //}

        this.childAgeListOfR.splice(0, this.childAgeListOfR.length);
        for (let p = 0; p < rValue; p++) {
          this.childAgeObj = new ChildAgeProps();
          this.childAgeObj.childAge = this.childAgeValueR;
          this.childAgeListOfR.push(this.childAgeObj);
        }
        var chAgeContR = document.querySelector(".child_age_containerR") as HTMLDivElement;
        chAgeContR.style.display = "flex";
      }
      else {
        var chAgeContR = document.querySelector(".child_age_containerR") as HTMLDivElement;
        chAgeContR.style.display = "none";
        this.childAgeListOfR.splice(0, this.childAgeListOfR.length);
      }

    }
    catch (ex) {
      console.log(ex);
    }
  }

  ChangeRoundwayInfantAge(infValueR) {
    try {
      if (infValueR != 0) {

        //this.childList = [];
        //for (let i = 0; i <= 9 - (this.roundtripSearchObj.adult + this.roundtripSearchObj.infant); i++) {
        //  let childItemR = new Number();
        //  childItemR = Number(i);
        //  this.childList.push(childItemR);
        //}

        this.infantAgeListOfR.splice(0, this.infantAgeListOfR.length);
        for (let p = 0; p < infValueR; p++) {
          this.infantAgeObj = new InfantAgeProps();
          this.infantAgeObj.infantAge = this.infantAgeValueR;
          this.infantAgeListOfR.push(this.infantAgeObj);
        }
        var inAgeContR = document.querySelector(".infant_age_containerR") as HTMLDivElement;
        inAgeContR.style.display = "flex";
      }
      else {
        var inAgeContNoR = document.querySelector(".infant_age_containerR") as HTMLDivElement;
        inAgeContNoR.style.display = "none";
        this.infantAgeListOfR.splice(0, this.infantAgeListOfR.length);
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }
  parseDate(dateString: string) {
    if (dateString) {
      return dateString;
    }
    return null;
  }
  //RoundtripSearchClick() {
  //  try {
  //    if (this.RoundTripValidation()) {
  //      //26-july-23
  //      if (this.roundtripSearchObj.prefferedAirline1 != "" || this.roundtripSearchObj.prefferedAirline2 != "" || this.roundtripSearchObj.prefferedAirline3 != "") {
  //        if (this.roundtripSearchObj.prefferedAirline1 == this.roundtripSearchObj.prefferedAirline2
  //          && this.roundtripSearchObj.prefferedAirline1 != "" && this.roundtripSearchObj.prefferedAirline2 != ""
  //          && this.roundtripSearchObj.prefferedAirline1 != null && this.roundtripSearchObj.prefferedAirline2 != null
  //          && this.roundtripSearchObj.prefferedAirline1 != undefined && this.roundtripSearchObj.prefferedAirline2 != undefined) {
  //          $("#lblError2").show();
  //          document.getElementById("lblError2").style.color = "#FE2C02";
  //          document.getElementById("lblError2").innerHTML = "You Cannot Select Same Preffed Airlines"
  //          $("#lblError2").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.roundtripSearchObj.prefferedAirline1 == this.roundtripSearchObj.prefferedAirline3
  //          && this.roundtripSearchObj.prefferedAirline1 != "" && this.roundtripSearchObj.prefferedAirline3 != ""
  //          && this.roundtripSearchObj.prefferedAirline1 != null && this.roundtripSearchObj.prefferedAirline3 != null
  //          && this.roundtripSearchObj.prefferedAirline1 != undefined && this.roundtripSearchObj.prefferedAirline3 != undefined) {
  //          $("#lblError2").show();
  //          document.getElementById("lblError2").style.color = "#FE2C02";
  //          document.getElementById("lblError2").innerHTML = "You Cannot Select Same Preffed Airlines"
  //          $("#lblError2").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.roundtripSearchObj.prefferedAirline2 == this.roundtripSearchObj.prefferedAirline3
  //          && this.roundtripSearchObj.prefferedAirline2 != "" && this.roundtripSearchObj.prefferedAirline3 != ""
  //          && this.roundtripSearchObj.prefferedAirline2 != null && this.roundtripSearchObj.prefferedAirline3 != null
  //          && this.roundtripSearchObj.prefferedAirline2 != undefined && this.roundtripSearchObj.prefferedAirline3 != undefined) {
  //          $("#lblError2").show();
  //          document.getElementById("lblError2").style.color = "#FE2C02";
  //          document.getElementById("lblError2").innerHTML = "You Cannot  Select Same Preffed Airlines"
  //          $("#lblError2").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.roundtripSearchObj.prefferedAirline1 == null) {
  //          this.roundtripSearchObj.prefferedAirline1 = "";
  //        }
  //        if (this.roundtripSearchObj.prefferedAirline2 == null) {
  //          this.roundtripSearchObj.prefferedAirline2 = "";
  //        }
  //        if (this.roundtripSearchObj.prefferedAirline3 == null) {
  //          this.roundtripSearchObj.prefferedAirline3 = "";
  //        }
  //      }
  //      //end
  //      document.getElementById("lblError2").style.display = "none";
  //      // alert(new Date(this.roundtripSearchObj.departureTime).toString());
  //      if (new Date(this.roundtripSearchObj.departureTime).toString() == "Invalid Date") {

  //        let departureDate = this.roundtripSearchObj.departureTime.split('/');
  //        let departure = (departureDate[2]) + "-" + (departureDate[1]) + "-" + (departureDate[0]);
  //        this.departureDates = new Date(departure);

  //      }
  //      //else if (this.roundtripSearchObj.departureTime.includes("/") )
  //      //{

  //      //  let departureDate = this.roundtripSearchObj.departureTime.split('/');
  //      //  let departure = (departureDate[2]) + "-" + (departureDate[1]) + "-" + (departureDate[0]);
  //      //  this.departureDates = new Date(departure);

  //      //}
  //      else {

  //        let departureDate = this.roundtripSearchObj.departureTime.toString().split('/');
  //        if (departureDate.length == 3) {

  //          //let departureDate = this.roundtripSearchObj.departureTime.split('/');
  //          let departure = (departureDate[2]) + "-" + (departureDate[1]) + "-" + (departureDate[0]);
  //          this.departureDates = new Date(departure);

  //        }
  //        else
  //          this.departureDates = new Date(this.roundtripSearchObj.departureTime);
  //      }

  //      if (new Date(this.roundtripSearchObj.returnDate).toString() == "Invalid Date") {
  //        let returnDate = this.roundtripSearchObj.returnDate.split('/');
  //        let datereturn = (returnDate[2]) + "-" + (returnDate[1]) + "-" + (returnDate[0]);
  //        this.returnDates = new Date(datereturn);
  //      }
  //      //else 
  //      else {
  //        let returnDate = this.roundtripSearchObj.returnDate.toString().split('/');
  //        if (returnDate.length == 3) {
  //          //let returnDate = this.roundtripSearchObj.returnDate.split('/');
  //          let datereturn = (returnDate[2]) + "-" + (returnDate[1]) + "-" + (returnDate[0]);
  //          this.returnDates = new Date(datereturn);
  //        }
  //        else
  //          this.returnDates = new Date(this.roundtripSearchObj.returnDate);
  //      }
  //      if (this.departureDates > this.returnDates) {
  //        document.getElementById("roundTripDateError").style.display = "block";
  //        document.getElementById("roundTripDateError").innerHTML = "Return Date Must be Greater Than or Equal to Departure";
  //        setTimeout(() => {
  //          document.getElementById("roundTripDateError").style.display = "none";
  //          document.getElementById("roundTripDateError").innerHTML = "";
  //        }, 6000)
  //      }
  //      else {


  //        if (this.haveRights) {


  //          let formatedReturnDate;
  //          this.searchObj = new FlightSearchProperties();
  //          try {
  //            let retD = this.roundtripSearchObj.returnDate;
  //            let days = retD.slice(0, 2);
  //            let month = retD.slice(3, 5);
  //            let year = retD.slice(6);
  //            formatedReturnDate = year + "-" + month + "-" + days;
  //          }
  //          catch (e) {
  //            let arrPipe: DatePipe = new DatePipe('en-US');
  //            formatedReturnDate = arrPipe.transform(this.roundtripSearchObj.returnDate, "yyyy-MM-dd");
  //          }
  //          let departCheck = new Date(this.roundTripDeparture);
  //          let returnCheck = new Date(formatedReturnDate);
  //          if (returnCheck < departCheck) {
  //            $("#lblError1RT").show();
  //            document.getElementById("lblError1RT").style.color = "#FE2C02";
  //            document.getElementById("lblError1RT").innerHTML = "You can not return before you depart.";
  //            $("#lblError1RT").delay(5000).hide(100);
  //            return false;
  //          }
  //          this.searchObj.agencyID = localStorage.getItem("AgencyId");
  //          this.searchObj.returnDate = formatedReturnDate;
  //          this.searchObj.adult = this.roundtripSearchObj.adult;
  //          this.searchObj.infant = this.roundtripSearchObj.infant;
  //          this.searchObj.child = this.roundtripSearchObj.child;
  //          this.searchObj.fareType = this.roundtripSearchObj.fareType;
  //          this.searchObj.cabinClass = this.roundtripSearchObj.cabinClass;
  //          this.searchObj.nonStopFlight = this.roundtripSearchObj.nonStopFlight;
  //          this.searchObj.nearByAirport = this.roundtripSearchObj.nearByAirport;
  //          this.searchObj.lowCostAirline = this.roundtripSearchObj.lowCostAirline;
  //          this.searchObj.gdsAirline = this.roundtripSearchObj.gdsAirline;
  //          this.searchObj.prefferedAirline1 = this.roundtripSearchObj.prefferedAirline1
  //          this.searchObj.prefferedAirline2 = this.roundtripSearchObj.prefferedAirline2;
  //          this.searchObj.prefferedAirline3 = this.roundtripSearchObj.prefferedAirline3;
  //          this.searchObj.tripType = "single-round";
  //          if (this.roundtripSearchObj.adult == null) {
  //            this.searchObj.adult = 0;
  //          }
  //          if (this.roundtripSearchObj.infant == null) {
  //            this.searchObj.infant = 0;
  //          }

  //          if (this.roundtripSearchObj.child == null) {
  //            this.searchObj.child = 0;
  //          }
  //          for (let n = 0; n < this.childAgeListOfR.length; n++) {
  //            this.searchObj.childAges.push(String(this.childAgeListOfR[n].childAge));
  //          }

  //          for (let q = 0; q < this.infantAgeListOfR.length; q++) {
  //            this.searchObj.infantAges.push(this.infantAgeListOfR[q].infantAge);
  //            if (this.searchObj.infantAges[q] == "less than 1") {
  //              this.searchObj.infantAges[q] = "0";
  //            }
  //            else if (this.roundtripSearchObj.infant == 0) {
  //              this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);
  //            }
  //          }
  //          // let obj = new FlightSearchDestinationProperties();
  //          for (let p = 0; p < this.searchObj.childAges.length; p++) {

  //            if (this.searchObj.child > 0 && this.searchObj.childAges[p].includes("undefined")) {

  //              $("#lblError1").show();

  //              document.getElementById("lblError1").style.color = "#FE2C02";

  //              document.getElementById("lblError1").innerHTML = "Please select ages for Child(ren).";

  //              $("#lblError1").delay(5000).hide(100);

  //              return false;

  //            }

  //          }

  //          for (let q = 0; q < this.searchObj.infantAges.length; q++) {

  //            if (this.searchObj.infant > 0 && this.searchObj.infantAges[q].includes("undefined")) {

  //              $("#lblError1").show();

  //              document.getElementById("lblError1").style.color = "#FE2C02";

  //              document.getElementById("lblError1").innerHTML = "Please select ages for Infant(s).";

  //              $("#lblError1").delay(5000).hide(100);

  //              return false;

  //            }

  //          }
  //          let start = this.roundTripFrom.indexOf(this.roundTripFrom[0]);
  //          let end = this.roundTripFrom.indexOf('-');
  //          this.roundwayFcity = this.roundTripFrom.slice(start, end);
  //          this.destinationObj.fromAirport = this.roundTripFrom;

  //          let start1 = this.roundTripTo.indexOf(this.roundTripTo[0]);
  //          let end2 = this.roundTripTo.indexOf('-');
  //          this.roundwayTcity = this.roundTripTo.slice(start, end);
  //          this.destinationObj.toAirport = this.roundTripTo;

  //          this.destinationObj.fromCity = this.roundwayFcity;
  //          this.destinationObj.toCity = this.roundwayTcity;
  //          this.destinationObj.departureDate = this.roundTripDeparture;
  //          //19-july-23

  //          for (let i = 0; i < this.airportList.length; i++) {
  //            if (this.roundwayFcity.trim() == this.airportList[i].iatA_CODE) {
  //              this.destinationObj.combineAirportFrom = this.airportList[i].combineAirportFrom;
  //              break;
  //            }

  //          }
  //          for (let i = 0; i < this.airportList.length; i++) {
  //            if (this.roundwayTcity.trim() == this.airportList[i].iatA_CODE) {
  //              this.destinationObj.combineAirportTo = this.airportList[i].combineAirportTo;
  //              break;
  //            }

  //          }

  //          //this.destinationObj.combineAirportTo=this.destinationObj.toCity.trim()+",";


  //          //end
  //          this.searchObj.flightLocationInfo.push(this.destinationObj);
  //          let obj = new FlightSearchDestinationProperties();
  //          obj.fromAirport = this.roundTripTo;
  //          obj.toAirport = this.roundTripFrom;

  //          obj.fromCity = this.roundwayTcity;
  //          obj.toCity = this.roundwayFcity;
  //          obj.departureDate = formatedReturnDate;
  //          //19-july-23
  //          for (let i = 0; i < this.airportList.length; i++) {
  //            if (obj.fromCity.trim() == this.airportList[i].iatA_CODE) {
  //              obj.combineAirportFrom = this.airportList[i].combineAirportFrom;
  //              break;
  //            }

  //          }



  //          for (let i = 0; i < this.airportList.length; i++) {
  //            if (obj.toCity.trim() == this.airportList[i].iatA_CODE) {
  //              obj.combineAirportTo = this.airportList[i].combineAirportTo;
  //              break;
  //            }

  //          }
  //          // obj.combineAirportTo=obj.toCity.trim()+",";

  //          //end

  //          this.searchObj.flightLocationInfo.push(obj);


  //          // console.log(this.searchObj);
  //          //this.flightService.flightSearchInsert(this.searchObj).subscribe((data) => {
  //          //  localStorage.setItem('flightResultData', JSON.stringify(data));
  //          //  this.router.navigateByUrl('/flightResults');
  //          //})

  //          // History
  //          //let searchHistoryObj = new FlightSearchHistory();
  //          //searchHistoryObj.agencyId = localStorage.getItem("AgencyId");
  //          //searchHistoryObj.userId = Number(localStorage.getItem("UserId"));
  //          //searchHistoryObj.fromAirport = this.destinationObj.fromAirport;
  //          //searchHistoryObj.toAirport = this.destinationObj.toAirport;
  //          //searchHistoryObj.fromCity = this.destinationObj.fromCity;
  //          //searchHistoryObj.toCity = this.destinationObj.toCity;
  //          //searchHistoryObj.departureDate = this.destinationObj.departureDate;
  //          //searchHistoryObj.tripType = "Roundway";
  //          //searchHistoryObj.travelClass = this.searchObj.cabinClass;
  //          //searchHistoryObj.fareType = this.searchObj.fareType;
  //          //searchHistoryObj.isNonStop = this.searchObj.nonStopFlight;
  //          //searchHistoryObj.isLowCost = this.searchObj.lowCostAirline;
  //          //searchHistoryObj.isGDSAirline = this.searchObj.gdsAirline;
  //          //searchHistoryObj.adults = this.searchObj.adult;
  //          //searchHistoryObj.children = this.searchObj.child;
  //          //searchHistoryObj.infants = this.searchObj.infant;
  //          //searchHistoryObj.returnDate = obj.departureDate;
  //          //searchHistoryObj.fromAirportReturn = obj.fromAirport;
  //          //searchHistoryObj.toAirportReturn = obj.toAirport;
  //          //searchHistoryObj.fromCityReturn = obj.fromCity;
  //          //searchHistoryObj.toCityReturn = obj.toCity;
  //          //this.addFlightSearchHistory(searchHistoryObj);

  //          //19-july-23
  //          // this.searchObj.nearByAirport=false;
  //          //end
  //          this.searchObj.journeyType = 2;
  //          localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));
  //          this.router.navigateByUrl('/flightResults');


  //        }
  //        else {
  //          $("#lblError2").show();
  //          document.getElementById("lblError2").style.color = "#FE2C02";
  //          document.getElementById("lblError2").innerHTML = "You don't have right to perform search."
  //          $("#lblError2").delay(5000).hide(100);
  //          return false;
  //        }


  //      }
  //    }
  //    else {
  //      document.getElementById("lblError2").style.display = "block";
  //      setTimeout(() => {
  //        document.getElementById("lblError2").style.display = "none";
  //      }, 6000)
  //    }

  //  }
  //  catch (e) {
  //    console.log(e);
  //  }
  //}
  //end....


  childAgeListOfM: ChildAgeProps[] = [];
  infantAgeListOfM: InfantAgeProps[] = [];
  childAgeItemM: number = 0;
  childAgeValueM: number;
  infantAgeValueM: string;
  ChangeMulticityChildAge(mValue) {
    try {
      if (mValue != 0) {

        //this.infantList = [];
        //if ((this.multiCitySearchObj.adult + mValue + this.multiCitySearchObj.infant) > 9) {
        //  this.multiCitySearchObj.infant = this.infantList.length;
        //  this.ChangeMulticityInfantAge(this.multiCitySearchObj.infant);
        //};

        //for (let i = 0; i <= 9 - (this.multiCitySearchObj.adult + mValue) && i <= this.multiCitySearchObj.adult; i++) {
        //  let infantItmeM = new Number();
        //  infantItmeM = Number(i);
        //  this.infantList.push(infantItmeM);
        //}

        this.childAgeListOfM.splice(0, this.childAgeListOfM.length);
        for (let p = 0; p < mValue; p++) {
          this.childAgeObj = new ChildAgeProps();
          this.childAgeObj.childAge = this.childAgeValueM;
          this.childAgeListOfM.push(this.childAgeObj);
        }
        var chAgeContM = document.querySelector(".child_age_containerM") as HTMLDivElement;
        chAgeContM.style.display = "flex";
      }
      else {
        var chAgeContM = document.querySelector(".child_age_containerM") as HTMLDivElement;
        chAgeContM.style.display = "none";
        this.childAgeListOfM.splice(0, this.childAgeListOfM.length);
      }

    }
    catch (ex) {
      console.log(ex);
    }

  }


  ChangeMulticityInfantAge(mValue) {
    try {
      if (mValue != 0) {

        //this.childList = [];
        //for (let i = 0; i <= 9 - (this.multiCitySearchObj.adult + this.multiCitySearchObj.infant); i++) {
        //  let childItemM = new Number();
        //  childItemM = Number(i);
        //  this.childList.push(childItemM);
        //}

        this.infantAgeListOfM.splice(0, this.infantAgeListOfM.length);
        for (let p = 0; p < mValue; p++) {
          this.infantAgeObj = new InfantAgeProps();
          this.infantAgeObj.infantAge = this.infantAgeValueM;
          this.infantAgeListOfM.push(this.infantAgeObj);
        }
        var inAgeContM = document.querySelector(".infant_age_containerM") as HTMLDivElement;
        inAgeContM.style.display = "flex";
      }
      else {
        var inAgeContNoM = document.querySelector(".infant_age_containerM") as HTMLDivElement;
        inAgeContNoM.style.display = "none";
      }
    }
    catch (ex) {
      console.log(ex);
    }
  }






  //MultiCitySearchClick() {


  //  try {
  //    if (this.MulticityValidation()) {
  //      //26-july-23
  //      if (this.multiCitySearchObj.prefferedAirline1 != "" || this.multiCitySearchObj.prefferedAirline2 != "" || this.multiCitySearchObj.prefferedAirline3 != "") {
  //        if (this.multiCitySearchObj.prefferedAirline1 == this.multiCitySearchObj.prefferedAirline2
  //          && this.multiCitySearchObj.prefferedAirline1 != "" && this.multiCitySearchObj.prefferedAirline2 != ""
  //          && this.multiCitySearchObj.prefferedAirline1 != null && this.multiCitySearchObj.prefferedAirline2 != null
  //          && this.multiCitySearchObj.prefferedAirline1 != undefined && this.multiCitySearchObj.prefferedAirline2 != undefined) {
  //          $("#lblError3").show();
  //          document.getElementById("lblError3").style.color = "#FE2C02";
  //          document.getElementById("lblError3").innerHTML = "You Cannot Select Same Preffed Airlines"
  //          $("#lblError3").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.multiCitySearchObj.prefferedAirline1 == this.multiCitySearchObj.prefferedAirline3
  //          && this.multiCitySearchObj.prefferedAirline1 != "" && this.multiCitySearchObj.prefferedAirline3 != ""
  //          && this.multiCitySearchObj.prefferedAirline1 != null && this.multiCitySearchObj.prefferedAirline3 != null
  //          && this.multiCitySearchObj.prefferedAirline1 != undefined && this.multiCitySearchObj.prefferedAirline3 != undefined) {
  //          $("#lblError3").show();
  //          document.getElementById("lblError3").style.color = "#FE2C02";
  //          document.getElementById("lblError3").innerHTML = "You Cannot Select Same Preffed Airlines"
  //          $("#lblError3").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.multiCitySearchObj.prefferedAirline2 == this.multiCitySearchObj.prefferedAirline3
  //          && this.multiCitySearchObj.prefferedAirline2 != "" && this.multiCitySearchObj.prefferedAirline3 != ""
  //          && this.multiCitySearchObj.prefferedAirline2 != null && this.multiCitySearchObj.prefferedAirline3 != null
  //          && this.multiCitySearchObj.prefferedAirline2 != undefined && this.multiCitySearchObj.prefferedAirline3 != undefined) {
  //          $("#lblError3").show();
  //          document.getElementById("lblError3").style.color = "#FE2C02";
  //          document.getElementById("lblError3").innerHTML = "You Cannot  Select Same Preffed Airlines"
  //          $("#lblError3").delay(5000).hide(100);
  //          return;
  //        }
  //        if (this.multiCitySearchObj.prefferedAirline1 == null) {
  //          this.multiCitySearchObj.prefferedAirline1 = "";
  //        }
  //        if (this.multiCitySearchObj.prefferedAirline2 == null) {
  //          this.multiCitySearchObj.prefferedAirline2 = "";
  //        }
  //        if (this.multiCitySearchObj.prefferedAirline3 == null) {
  //          this.multiCitySearchObj.prefferedAirline3 = "";
  //        }
  //      }
  //      //end
  //      document.getElementById("lblError3").style.display = "none";
  //      document.getElementById("lblError3").innerHTML = "";
  //      if (this.haveRights && this.defaultMulticityDiv.length > 1) {

  //        this.searchObj = new FlightSearchProperties();
  //        this.searchObj.agencyID = localStorage.getItem("AgencyId");

  //        this.searchObj.adult = this.multiCitySearchObj.adult;

  //        this.searchObj.infant = this.multiCitySearchObj.infant;

  //        this.searchObj.child = this.multiCitySearchObj.child;

  //        this.searchObj.tripType = "multi";

  //        this.searchObj.fareType = this.multiCitySearchObj.fareType;

  //        this.searchObj.cabinClass = this.multiCitySearchObj.cabinClass;

  //        /*this.searchObj.departureTime = this.multiCitySearchObj.departureTime;*/

  //        this.searchObj.nonStopFlight = this.multiCitySearchObj.nonStopFlight;

  //        /*this.searchObj.nearByAirport = this.multiCitySearchObj.nearByAirport;*/

  //        /*this.searchObj.lowCostAirline = this.multiCitySearchObj.lowCostAirline;*/

  //        /*this.searchObj.gdsAirline = this.multiCitySearchObj.gdsAirline;*/

  //        this.searchObj.prefferedAirline1 = this.multiCitySearchObj.prefferedAirline1;

  //        this.searchObj.prefferedAirline2 = this.multiCitySearchObj.prefferedAirline2;

  //        this.searchObj.prefferedAirline3 = this.multiCitySearchObj.prefferedAirline3;
  //        if (this.multiCitySearchObj.adult == null) {
  //          this.searchObj.adult = 0;
  //        }

  //        if (this.multiCitySearchObj.infant == null) {
  //          this.searchObj.infant = 0;
  //        }

  //        if (this.multiCitySearchObj.child == null) {
  //          this.searchObj.child = 0;
  //        }


  //        for (let n = 0; n < this.childAgeListOfM.length; n++) {

  //          this.searchObj.childAges.push(String(this.childAgeListOfM[n].childAge));

  //        }

  //        for (let q = 0; q < this.infantAgeListOfM.length; q++) {

  //          this.searchObj.infantAges.push(this.infantAgeListOfM[q].infantAge);

  //          if (this.searchObj.infantAges[q] == "less than 1") {

  //            this.searchObj.infantAges[q] = "0";

  //          }

  //          else if (this.multiCitySearchObj.infant == 0) {

  //            this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);

  //          }

  //        }

  //        for (let p = 0; p < this.searchObj.childAges.length; p++) {



  //          if (this.searchObj.child > 0 && this.searchObj.childAges[p].includes("undefined")) {



  //            $("#lblError1").show();



  //            document.getElementById("lblError1").style.color = "#FE2C02";



  //            document.getElementById("lblError1").innerHTML = "Please select ages for Child(ren).";



  //            $("#lblError1").delay(5000).hide(100);



  //            return false;



  //          }



  //        }



  //        for (let q = 0; q < this.searchObj.infantAges.length; q++) {



  //          if (this.searchObj.infant > 0 && this.searchObj.infantAges[q].includes("undefined")) {



  //            $("#lblError1").show();



  //            document.getElementById("lblError1").style.color = "#FE2C02";



  //            document.getElementById("lblError1").innerHTML = "Please select ages for Infant(s).";



  //            $("#lblError1").delay(5000).hide(100);



  //            return false;



  //          }



  //        }

  //        this.searchObj.flightLocationInfo = this.defaultMulticityDiv;



  //        for (let i = 0; i < this.searchObj.flightLocationInfo.length; i++) {

  //          let start = this.searchObj.flightLocationInfo[i].fromAirport.indexOf(this.searchObj.flightLocationInfo[i].fromAirport[0]);

  //          let end = this.searchObj.flightLocationInfo[i].fromAirport.indexOf('-');

  //          this.searchObj.flightLocationInfo[i].fromCity = this.searchObj.flightLocationInfo[i].fromAirport.slice(start, end).trim();



  //          if (this.searchObj.flightLocationInfo[i].departureDate.toString().includes("/")) {

  //            let retD = this.searchObj.flightLocationInfo[i].departureDate;

  //            let days = retD.slice(0, 2);

  //            let month = retD.slice(3, 5);

  //            let year = retD.slice(6);

  //            this.searchObj.flightLocationInfo[i].departureDate = year + "-" + month + "-" + days;

  //          } else {

  //            let modiObjRTPipe: DatePipe = new DatePipe('en-US');

  //            this.searchObj.flightLocationInfo[i].departureDate = (modiObjRTPipe.transform(this.searchObj.flightLocationInfo[i].departureDate, "yyyy-MM-dd"));

  //          }
  //          //19-july-23
  //          let start1 = this.searchObj.flightLocationInfo[i].toAirport.indexOf(this.searchObj.flightLocationInfo[i].toAirport[0]);

  //          let end1 = this.searchObj.flightLocationInfo[i].toAirport.indexOf('-');

  //          this.searchObj.flightLocationInfo[i].toCity = this.searchObj.flightLocationInfo[i].toAirport.slice(start1, end1).trim();


  //          for (let j = 0; j < this.airportList.length; j++) {
  //            if (this.searchObj.flightLocationInfo[i].fromCity.trim() == this.airportList[j].iatA_CODE) {
  //              this.searchObj.flightLocationInfo[i].combineAirportFrom = this.airportList[j].combineAirportFrom;
  //              break;
  //            }

  //          }
  //          for (let k = 0; k < this.airportList.length; k++) {
  //            if (this.searchObj.flightLocationInfo[i].toCity.trim() == this.airportList[k].iatA_CODE) {
  //              this.searchObj.flightLocationInfo[i].combineAirportTo = this.airportList[k].combineAirportTo;
  //              break;
  //            }

  //          }
  //          //end

  //          //console.log(this.destinationObj.toCity);

  //          //this.searchObj.flightLocationInfo.push(this.destinationObj);



  //        }



  //        // History

  //        //let searchHistoryObj = new FlightSearchHistory();

  //        //searchHistoryObj.agencyId = localStorage.getItem("AgencyId");

  //        //searchHistoryObj.userId = Number(localStorage.getItem("UserId"));

  //        //for (let b = 0; b < this.searchObj.flightLocationInfo.length; b++) {

  //        //  searchHistoryObj.fromAirport += this.searchObj.flightLocationInfo[b].fromAirport + ", ";

  //        //  searchHistoryObj.toAirport += this.searchObj.flightLocationInfo[b].toAirport + ", ";

  //        //  searchHistoryObj.departureDate += this.searchObj.flightLocationInfo[b].departureDate + ", ";

  //        //  searchHistoryObj.fromCity += this.searchObj.flightLocationInfo[b].fromCity + ", ";

  //        //  searchHistoryObj.toCity += this.searchObj.flightLocationInfo[b].toCity + ", ";

  //        //}

  //        //let fromAirports = searchHistoryObj.fromAirport.trimRight();

  //        //let toAirports = searchHistoryObj.toAirport.trimRight();

  //        //let departureDates = searchHistoryObj.departureDate.trimRight();

  //        //let fromCities = searchHistoryObj.fromCity.trimRight();

  //        //let toCities = searchHistoryObj.toCity.trimRight();

  //        //searchHistoryObj.fromAirport = fromAirports.slice(0, -1);

  //        //searchHistoryObj.toAirport = toAirports.slice(0, -1);

  //        //searchHistoryObj.departureDate = departureDates.slice(0, -1);

  //        //searchHistoryObj.fromCity = fromCities.slice(0, -1);

  //        //searchHistoryObj.toCity = toCities.slice(0, -1);

  //        //searchHistoryObj.tripType = "Multi City";

  //        //searchHistoryObj.travelClass = this.searchObj.cabinClass;

  //        //searchHistoryObj.fareType = this.searchObj.fareType;

  //        //searchHistoryObj.isNonStop = this.searchObj.nonStopFlight;

  //        //searchHistoryObj.isLowCost = this.searchObj.lowCostAirline;

  //        //searchHistoryObj.isGDSAirline = this.searchObj.gdsAirline;

  //        //searchHistoryObj.adults = this.searchObj.adult;

  //        //searchHistoryObj.children = this.searchObj.child;

  //        //searchHistoryObj.infants = this.searchObj.infant;

  //        //searchHistoryObj.returnDate = "N/A";

  //        //this.addFlightSearchHistory(searchHistoryObj);
  //        this.searchObj.journeyType = 3;
  //        //26-july-23
  //        this.searchObj.gdsAirline = this.multiCitySearchObj.gdsAirline;
  //        this.searchObj.lowCostAirline = this.multiCitySearchObj.lowCostAirline;
  //        this.searchObj.nearByAirport = this.multiCitySearchObj.nearByAirport;
  //        //end
  //        localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));

  //        this.router.navigateByUrl('/flightResults');

  //      }

  //      else {

  //        $("#lblError3").show();

  //        document.getElementById("lblError3").style.color = "#FE2C02";

  //        document.getElementById("lblError3").innerHTML = "You don't have right to perform search."

  //        $("#lblError3").delay(5000).hide(100);

  //        return false;

  //      }
  //    }
  //    else {
  //      document.getElementById("lblError3").style.display = "block";
  //      document.getElementById("lblError3").innerHTML = "Please Enter Required Fields ";
  //      setTimeout(() => {
  //        document.getElementById("lblError3").style.display = "none";
  //        document.getElementById("lblError3").innerHTML = "";
  //      }, 6000)
  //    }

  //  }

  //  catch (e) { }

  //}

  importButton() {
    //console.log(this.importPNR);

    var loader = document.getElementById("loaderissue") as HTMLDivElement;
    loader.classList.remove("loaders");
    try {

      this.importPNR.importAgency = localStorage.getItem("AgencyId");
      this.importPNR.importUser = Number(localStorage.getItem("UserId"));
      this.importPNR.parentHierarchy = localStorage.getItem("ParentHierarchy");
      this.flightService.importPNR(this.importPNR).subscribe((data) => {

        var loaders = document.getElementById("loaderissue") as HTMLDivElement;
        loaders.classList.add("loaders");
        if (data.isSaved) {
          var loaderf = document.getElementById("loaderissue") as HTMLDivElement;
          loaderf.classList.add("loaders");
          //localStorage.setItem('importPNRID', JSON.stringify(data.importPnrAgencyDetailsInfo.importID));

          this.router.navigateByUrl('/importPNRList');
        }
        else {
          document.getElementById("importpnridmessage").innerHTML = data.errorInfo;
          setTimeout(function () {
            document.getElementById("importpnridmessage").innerHTML = "";
          }, 6000);
        }

      });

    }
    catch (e) { }

  }

  //addFlightSearchHistory(searchHistoryObj) {
  //  this.flightService.flightSearchHistoryInsert(searchHistoryObj).subscribe(data => {
  //  });
  //}

  getFlightSearchHistory() {
    this.flightService.getFlightSearchHistory(Number(localStorage.getItem("UserId")), localStorage.getItem("AgencyId")).subscribe((data) => {
      this.searchHistoryList = data;
      for (let j = 0; j < this.searchHistoryList.length; j++) {
        this.popoverArray.push(false);
      }
    });
  }

  searchWithHistory(n: number) {

    if (this.searchHistoryList[n].tripType == "Oneway") {
      let onewayTripValue: string = "oneway";
      this.ChangeFlightTrip(onewayTripValue);
      this.onewayFrom = this.searchHistoryList[n].fromAirport;
      this.onewayTo = this.searchHistoryList[n].toAirport;
      let dateDepartLong: Date = new Date(this.searchHistoryList[n].departureDate);
      dateDepartLong.setHours(0);
      dateDepartLong.setMinutes(0);
      dateDepartLong.setSeconds(0);
      dateDepartLong.setMilliseconds(0);
      let datePipe: DatePipe = new DatePipe('en-US');
      this.onewayDepartureDate = (datePipe.transform(dateDepartLong, "dd/MM/yyyy"));
      //this.onewayDepartureDate = this.searchHistoryList[n].departureDate;
      this.onewaySearchObj.adult = this.searchHistoryList[n].adults;
      this.onewaySearchObj.child = this.searchHistoryList[n].children;
      this.onewaySearchObj.infant = this.searchHistoryList[n].infants;
      this.onewaySearchObj.cabinClass = this.searchHistoryList[n].travelClass;
      this.onewaySearchObj.fareType = this.searchHistoryList[n].fareType;
      this.ChangeOnewayChildAge(this.onewaySearchObj.child);
      this.ChangeOnewayInfantAge(this.onewaySearchObj.infant);


    }

    else if (this.searchHistoryList[n].tripType == "Roundway") {
      let roundwayTripValue: string = "roundtrip";
      this.ChangeFlightTrip(roundwayTripValue);
      this.roundTripFrom = this.searchHistoryList[n].fromAirport;
      this.roundTripTo = this.searchHistoryList[n].toAirport;
      let dateDepart: Date = new Date(this.searchHistoryList[n].departureDate);
      dateDepart.setHours(0);
      dateDepart.setMinutes(0);
      dateDepart.setSeconds(0);
      dateDepart.setMilliseconds(0);
      let datePipe: DatePipe = new DatePipe('en-US');
      this.roundtripSearchObj.departureTime = (datePipe.transform(dateDepart, "dd/MM/yyyy"));

      let dateReturn: Date = new Date(this.searchHistoryList[n].returnDate);
      dateReturn.setHours(0);
      dateReturn.setMinutes(0);
      dateReturn.setSeconds(0);
      dateReturn.setMilliseconds(0);
      let datePipeReturn: DatePipe = new DatePipe('en-US');
      this.roundtripSearchObj.returnDate = (datePipeReturn.transform(dateReturn, "dd/MM/yyyy"));

      //this.roundtripSearchObj.returnDate = this.searchHistoryList[n].returnDate;
      this.roundtripSearchObj.adult = this.searchHistoryList[n].adults;
      this.roundtripSearchObj.child = this.searchHistoryList[n].children;
      this.roundtripSearchObj.infant = this.searchHistoryList[n].infants;
      this.roundtripSearchObj.cabinClass = this.searchHistoryList[n].travelClass;
      this.roundtripSearchObj.cabinClassReturnTrip = this.searchHistoryList[n].returnTravelClass;
      this.roundtripSearchObj.fareType = this.searchHistoryList[n].fareType;
      this.ChangeRoundwayChildAge(this.roundtripSearchObj.child);
      this.ChangeRoundwayInfantAge(this.roundtripSearchObj.infant);
      this.roundwayDuration = Number(this.searchHistoryList[n].duration);

    }

    else if (this.searchHistoryList[n].tripType == "Multi City") {

      let multicityTripValue: string = "multicity";

      this.ChangeFlightTrip(multicityTripValue);

      var fromAirportList = this.searchHistoryList[n].fromAirport.split(",");

      var toAirportList = this.searchHistoryList[n].toAirport.split(",");

      var departDateList = this.searchHistoryList[n].departureDate.split(",");

      this.defaultMulticityDiv = [];

      for (let a = 0; a < fromAirportList.length; a++) {

        let fsdpObj = new FlightSearchDestinationProperties();

        fsdpObj.fromAirport = fromAirportList[a].trim();

        fsdpObj.toAirport = toAirportList[a].trim();

        let dateDepart: Date = new Date(departDateList[a].trim());

        dateDepart.setHours(0);

        dateDepart.setMinutes(0);

        dateDepart.setSeconds(0);

        dateDepart.setMilliseconds(0);

        let datePipeDepart: DatePipe = new DatePipe('en-US');

        fsdpObj.departureDate = (datePipeDepart.transform(dateDepart, "dd/MM/yyyy"));

        this.defaultMulticityDiv.push(fsdpObj);

      }

      this.multiCitySearchObj.adult = this.searchHistoryList[n].adults;

      this.multiCitySearchObj.child = this.searchHistoryList[n].children;

      this.multiCitySearchObj.infant = this.searchHistoryList[n].infants;

      this.multiCitySearchObj.cabinClass = this.searchHistoryList[n].travelClass;

      this.multiCitySearchObj.fareType = this.searchHistoryList[n].fareType;

      this.ChangeMulticityChildAge(this.multiCitySearchObj.child);

      this.ChangeMulticityInfantAge(this.multiCitySearchObj.infant);



    }
    //else if (this.searchHistoryList[n].tripType == "Multi City") {
    //  for (let k = 0; k < this.defaultMulticityDiv.length; k++) {

    //  }
    //}

  }

  pnrCancelClick() { }
  OfflineRequest() {
    localStorage.setItem('fromOfflineRequestRoute', 'OfflineRequestList');
    this.router.navigateByUrl('/offlineRequestList');
  }


  //OnewayValidation() {

  //  if (this.onewayFrom != "" && this.onewayTo != "" && this.onewayDepartureDate != "") {
  //    return true;
  //  }
  //  else {
  //    return false;
  //  }
  //}

  //RoundTripValidation() {
  //  if (this.roundTripFrom != "" && this.roundTripTo != "" && this.roundtripSearchObj.departureTime != "" && this.roundtripSearchObj.returnDate != null) {

  //    return true;
  //  }
  //  else {
  //    return false;
  //  }
  //}

  //MulticityValidation() {
  //  let success = false;
  //  // console.log(this.defaultMulticityDiv[0].departureDate)
  //  for (let i = 0; i < this.defaultMulticityDiv.length; i++) {
  //    if (this.defaultMulticityDiv[i].fromAirport != "" && this.defaultMulticityDiv[i].toAirport != "" && this.defaultMulticityDiv[i].departureDate != "") {
  //      success = true;
  //    }
  //    else {
  //      success = false;
  //      break;
  //    }
  //  }
  //  if (success == true) {
  //    return true;
  //  }
  //  else {
  //    return false;
  //  }
  //}

  GroupTicketClick = (index: number): void => {
    this.searchObj.byPassSearch = true;

    this.searchObj.agencyID = localStorage.getItem("AgencyId")
    this.searchObj.tripType = "single-round";
    if (this.groupTicketList[index].isAdult) {
      this.searchObj.adult = 1;
    }
    if (this.groupTicketList[index].isChild) {
      this.searchObj.child = 1;
    }
    if (this.groupTicketList[index].isInfant) {
      this.searchObj.infant = 1;
    }
    let flightSearch = new FlightSearchDestinationProperties();
    this.searchObj.flightLocationInfo = [];
    this.searchObj.flightLocationInfo.push(flightSearch);
    this.searchObj.flightLocationInfo[0].departureDate = String(this.groupTicketList[index].departureDate).split("T")[0];
    this.searchObj.flightLocationInfo[0].fromCity = this.groupTicketList[index].onewayFromAirport;
    this.searchObj.flightLocationInfo[0].toCity = this.groupTicketList[index].onewayToAirport;
    let flightSearchs = new FlightSearchDestinationProperties();
    if (this.groupTicketList[index].returnFromAirport != "") {
      this.searchObj.flightLocationInfo.push(flightSearchs);
      this.searchObj.flightLocationInfo[1].departureDate = String(this.groupTicketList[index].returnDate).split("T")[0];
      this.searchObj.returnDate = this.searchObj.flightLocationInfo[1].departureDate;
      this.searchObj.flightLocationInfo[1].fromCity = this.groupTicketList[index].returnFromAirport;
      this.searchObj.flightLocationInfo[1].toCity = this.groupTicketList[index].returnToAirport;
      this.searchObj.journeyType = 2;
    }
    else {
      this.searchObj.journeyType = 1;
    }
    const fromAirport = this.airportList.find(air => air.iatA_CODE === this.searchObj.flightLocationInfo[0].fromCity)
    this.searchObj.flightLocationInfo[0].fromAirport = fromAirport.airportName;
    const toAirport = this.airportList.find(air => air.iatA_CODE === this.searchObj.flightLocationInfo[0].toCity)
    this.searchObj.flightLocationInfo[0].toAirport = toAirport.airportName;
    localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));
    this.router.navigateByUrl('/flightResults');

  }



///asad


  AddNewFlight() {
    // Function to display error messages
    function displayError(message) {
      const errorElement = document.getElementById("lblError3");
      errorElement.style.display = "block";
      errorElement.style.color = "#FE2C02";
      errorElement.innerHTML = message;
      setTimeout(() => {
        errorElement.style.display = "none";
        errorElement.innerHTML = "";
      }, 8000);
    }

    let obj = new FlightSearchDestinationProperties();
    let divs = this.defaultMulticityDiv;

    // Check if all existing segments are filled and dates are in order
    for (let i = 0; i < divs.length; i++) {
      if (divs[i].fromAirport === "" || divs[i].fromAirport === null || divs[i].toAirport === "" || divs[i].toAirport === null ||
        divs[i].departureDate === "" || divs[i].departureDate === undefined) {
        displayError("Please fill the required fields");
        return;
      }
      //if (i > 0 && divs[i].departureDate < divs[i - 1].departureDate) {
      //  displayError("Each segment's departure date must be greater than or equal to the previous segment's departure date");
      //  return;
      //}
    }

    // Add the new segment if all checks pass
    divs.push(obj);

    // Hide the "Add Flight" button if there are 6 segments
    if (divs.length == 6) {
      $("#addFlightbtn").hide();
    }
  }


  MulticityValidation() {

    function displayError(message) {
      const errorElement = document.getElementById("lblError3");
      errorElement.style.display = "block";
      errorElement.style.color = "#FE2C02";
      errorElement.innerHTML = message;
      setTimeout(() => {
        errorElement.style.display = "none";
        errorElement.innerHTML = "";
      }, 8000);
    }

    let divs = this.defaultMulticityDiv;

    // Check if all existing segments are filled and dates are in order
    for (let i = 0; i < divs.length; i++) {
      if (
        (divs[i].fromAirport === "" || divs[i].fromAirport === null) || (divs[i].toAirport === "" || divs[i].toAirport === null) ||
        (divs[i].departureDate === "" || divs[i].departureDate === undefined)
      ) {
        displayError("Please fill the required fields");
        return false;
      }
      //if (i > 0) {
      //  if (divs[i].departureDate.includes("/")) {

      //    let split = divs[i].departureDate.split("/");
      //    let datezero = split[2] + "-" + split[1] + "-" + split[0];
      //    let split1 = divs[i - 1].departureDate.split("/");
      //    let dateOne = split1[2] + "-" + split1[1] + "-" + split1[0];
      //    const depdates = new Date(datezero);
      //    const depdate1 = new Date(dateOne);
      //    if (depdates < depdate1) {
      //      displayError("Each segment's departure date must be greater than or equal to the previous segment's departure date");
      //      return false;
      //    }
      //  }

      //  else {
      //    const depdates = new Date(divs[i].departureDate);
      //    const depdate1 = new Date(divs[i - 1].departureDate);
      //    if (depdates < depdate1) {
      //      displayError("Each segment's departure date must be greater than or equal to the previous segment's departure date");
      //      return false;
      //    }
      //  }
      //}
    }

    return true;

  }



  RoundTripValidation() {

    function displayError(message) {
      const errorElement = document.getElementById("lblError2");
      errorElement.style.display = "block";
      errorElement.style.color = "#FE2C02";
      errorElement.innerHTML = message;
      setTimeout(() => {
        errorElement.style.display = "none";
        errorElement.innerHTML = "";
      }, 8000);
    }

    if (
      (this.roundTripFrom === "" || this.roundTripFrom === null) ||
      (this.roundTripTo === "" || this.roundTripTo === null) ||
      (this.roundtripSearchObj.departureTime === "" || this.roundtripSearchObj.departureTime === undefined) ||
      (this.roundtripSearchObj.returnDate === null || this.roundtripSearchObj.returnDate === undefined)
    ) {
      displayError("Please fill the required fields");
      return false;
    }
    else {
      return true;
    }
  }



  OnewayValidation() {
    function displayError(message) {
      const errorElement = document.getElementById("lblError1");
      errorElement.style.display = "block";
      errorElement.style.color = "#FE2C02";
      errorElement.innerHTML = message;
      setTimeout(() => {
        errorElement.style.display = "none";
        errorElement.innerHTML = "";
      }, 8000);
    }


    if (
      (this.onewayFrom === "" || this.onewayFrom === null) ||
      (this.onewayTo === "" || this.onewayTo === null) ||
      (this.onewayDepartureDate === "" || this.onewayDepartureDate === undefined)
    ) {
      displayError("Please fill the required fields");
      return false;
    }
    else {
      return true;
    }
  }



  OnewaySearchClick() {
    try {
      if (this.OnewayValidation()) {
        //26-july-23
        if (this.onewaySearchObj.prefferedAirline1 != "" || this.onewaySearchObj.prefferedAirline2 != "" || this.onewaySearchObj.prefferedAirline3 != "") {
          if (this.onewaySearchObj.prefferedAirline1 == this.onewaySearchObj.prefferedAirline2
            && this.onewaySearchObj.prefferedAirline1 != "" && this.onewaySearchObj.prefferedAirline2 != ""
            && this.onewaySearchObj.prefferedAirline1 != null && this.onewaySearchObj.prefferedAirline2 != null
            && this.onewaySearchObj.prefferedAirline1 != undefined && this.onewaySearchObj.prefferedAirline2 != undefined) {
            $("#lblError1").show();
            document.getElementById("lblError1").style.color = "#FE2C02";
            document.getElementById("lblError1").innerHTML = "You Cannot Select Same Preffed Airlines"
            $("#lblError1").delay(5000).hide(100);
            return;
          }
          if (this.onewaySearchObj.prefferedAirline1 == this.onewaySearchObj.prefferedAirline3
            && this.onewaySearchObj.prefferedAirline1 != "" && this.onewaySearchObj.prefferedAirline3 != ""
            && this.onewaySearchObj.prefferedAirline1 != null && this.onewaySearchObj.prefferedAirline3 != null
            && this.onewaySearchObj.prefferedAirline1 != undefined && this.onewaySearchObj.prefferedAirline3 != undefined) {
            $("#lblError1").show();
            document.getElementById("lblError1").style.color = "#FE2C02";
            document.getElementById("lblError1").innerHTML = "You Cannot Select Same Preffed Airlines"
            $("#lblError1").delay(5000).hide(100);
            return;
          }
          if (this.onewaySearchObj.prefferedAirline2 == this.onewaySearchObj.prefferedAirline3
            && this.onewaySearchObj.prefferedAirline2 != "" && this.onewaySearchObj.prefferedAirline3 != ""
            && this.onewaySearchObj.prefferedAirline2 != null && this.onewaySearchObj.prefferedAirline3 != null
            && this.onewaySearchObj.prefferedAirline2 != undefined && this.onewaySearchObj.prefferedAirline3 != undefined) {
            $("#lblError1").show();
            document.getElementById("lblError1").style.color = "#FE2C02";
            document.getElementById("lblError1").innerHTML = "You Cannot Select Same Preffed Airlines"
            $("#lblError1").delay(5000).hide(100);
            return;
          }
          if (this.onewaySearchObj.prefferedAirline1 == null) {
            this.onewaySearchObj.prefferedAirline1 = "";
          }
          if (this.onewaySearchObj.prefferedAirline2 == null) {
            this.onewaySearchObj.prefferedAirline2 = "";
          }
          if (this.onewaySearchObj.prefferedAirline3 == null) {
            this.onewaySearchObj.prefferedAirline3 = "";
          }
        }
        //end
        document.getElementById("lblError1").style.display = "none";

        if (this.haveRights) {
          this.searchObj = new FlightSearchProperties();
          this.searchObj.agencyID = localStorage.getItem("AgencyId");
          this.searchObj.parentHierarchy = localStorage.getItem("ParentHierarchy");
          this.searchObj.adult = this.onewaySearchObj.adult;
          this.searchObj.infant = this.onewaySearchObj.infant;
          this.searchObj.child = this.onewaySearchObj.child;
          this.searchObj.fareType = this.onewaySearchObj.fareType;
          this.searchObj.cabinClass = this.onewaySearchObj.cabinClass;
          this.searchObj.departureTime = this.onewaySearchObj.departureTime;
          this.searchObj.nonStopFlight = this.onewaySearchObj.nonStopFlight;
          this.searchObj.nearByAirport = this.onewaySearchObj.nearByAirport;
          this.searchObj.lowCostAirline = this.onewaySearchObj.lowCostAirline;
          this.searchObj.gdsAirline = this.onewaySearchObj.gdsAirline;
          this.searchObj.prefferedAirline1 = this.onewaySearchObj.prefferedAirline1
          this.searchObj.prefferedAirline2 = this.onewaySearchObj.prefferedAirline2;
          this.searchObj.prefferedAirline3 = this.onewaySearchObj.prefferedAirline3;
          if (this.onewaySearchObj.adult == null) {
            this.searchObj.adult = 0;
          }
          if (this.onewaySearchObj.infant == null) {
            this.searchObj.infant = 0;
          }
          if (this.onewaySearchObj.child == null) {
            this.searchObj.child = 0;
          }
          for (let n = 0; n < this.childAgeListOf.length; n++) {
            this.searchObj.childAges.push(String(this.childAgeListOf[n].childAge));
          }
          for (let q = 0; q < this.infantAgeListOf.length; q++) {
            this.searchObj.infantAges.push(this.infantAgeListOf[q].infantAge);
            if (this.searchObj.infantAges[q] == "less than 1") {
              this.searchObj.infantAges[q] = "0";
            }
            else if (this.onewaySearchObj.infant == 0) {
              this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);
            }
          }
          for (let p = 0; p < this.searchObj.childAges.length; p++) {
            // ==== Asad Working =======
            if (this.searchObj.child > 0 && (this.searchObj.childAges[p].includes("undefined") || this.searchObj.childAges[p].includes("null"))) {
              $("#lblError1").show();
              document.getElementById("lblError1").style.color = "#FE2C02";
              document.getElementById("lblError1").innerHTML = "Please select ages for Child(ren).";
              $("#lblError1").delay(5000).hide(100);
              return false;
            }

          }

          for (let q = 0; q < this.searchObj.infantAges.length; q++) {
            // ==== Asad Working =======
            if (this.searchObj.infant > 0 && (this.searchObj.infantAges[q] === null || this.searchObj.infantAges[q] === undefined)) {
              $("#lblError1").show();
              document.getElementById("lblError1").style.color = "#FE2C02";
              document.getElementById("lblError1").innerHTML = "Please select ages for Infant(s).";
              $("#lblError1").delay(5000).hide(100);
              return false;
            }
          }

          this.searchObj.tripType = "single-round";
          // let obj = new FlightSearchDestinationProperties();
          let start = this.onewayFrom.indexOf(this.onewayFrom[0]);
          let end = this.onewayFrom.indexOf('-');
          this.onewayFcity = this.onewayFrom.slice(start, end);
          this.destinationObj.fromAirport = this.onewayFrom;
          let start1 = this.onewayTo.indexOf(this.onewayTo[0]);
          let end1 = this.onewayTo.indexOf('-');
          this.onewayTcity = this.onewayTo.slice(start, end);
          this.destinationObj.toAirport = this.onewayTo;
          this.destinationObj.fromCity = this.onewayFcity;
          this.destinationObj.toCity = this.onewayTcity;
          this.destinationObj.departureDate = this.onewayDeparture;
          //19-july-23


          for (let i = 0; i < this.airportList.length; i++) {

            if (this.onewayFcity.trim() == this.airportList[i].iatA_CODE) {
              this.destinationObj.combineAirportFrom = this.airportList[i].combineAirportFrom;
              break;
            }

          }
          for (let i = 0; i < this.airportList.length; i++) {
            if (this.onewayTcity.trim() == this.airportList[i].iatA_CODE) {
              this.destinationObj.combineAirportTo = this.airportList[i].combineAirportTo;

              break;
            }

          }

          //end
          this.searchObj.flightLocationInfo.push(this.destinationObj);


          this.searchObj.journeyType = 1;
          localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));
          this.router.navigateByUrl('/flightResults');
        }
        else {
          $("#lblError1").show();
          document.getElementById("lblError1").style.color = "#FE2C02";
          document.getElementById("lblError1").innerHTML = "You don't have right to perform search."
          $("#lblError1").delay(5000).hide(100);
          return false;
        }

      }
      else {

        //document.getElementById("lblError1").style.display = "block";
        //setTimeout(() => {
        //  document.getElementById("lblError1").style.display = "none";
        //}, 6000)

        //return false;
      }

    }
    catch (e) {
      // console.log(e);
    }
  }


  RoundtripSearchClick() {
    try {
      if (this.RoundTripValidation()) {
        //26-july-23
        if (this.roundtripSearchObj.prefferedAirline1 != "" || this.roundtripSearchObj.prefferedAirline2 != "" || this.roundtripSearchObj.prefferedAirline3 != "") {
          if (this.roundtripSearchObj.prefferedAirline1 == this.roundtripSearchObj.prefferedAirline2
            && this.roundtripSearchObj.prefferedAirline1 != "" && this.roundtripSearchObj.prefferedAirline2 != ""
            && this.roundtripSearchObj.prefferedAirline1 != null && this.roundtripSearchObj.prefferedAirline2 != null
            && this.roundtripSearchObj.prefferedAirline1 != undefined && this.roundtripSearchObj.prefferedAirline2 != undefined) {
            $("#lblError2").show();
            document.getElementById("lblError2").style.color = "#FE2C02";
            document.getElementById("lblError2").innerHTML = "You Cannot Select Same Preffed Airlines"
            $("#lblError2").delay(5000).hide(100);
            return;
          }
          if (this.roundtripSearchObj.prefferedAirline1 == this.roundtripSearchObj.prefferedAirline3
            && this.roundtripSearchObj.prefferedAirline1 != "" && this.roundtripSearchObj.prefferedAirline3 != ""
            && this.roundtripSearchObj.prefferedAirline1 != null && this.roundtripSearchObj.prefferedAirline3 != null
            && this.roundtripSearchObj.prefferedAirline1 != undefined && this.roundtripSearchObj.prefferedAirline3 != undefined) {
            $("#lblError2").show();
            document.getElementById("lblError2").style.color = "#FE2C02";
            document.getElementById("lblError2").innerHTML = "You Cannot Select Same Preffed Airlines"
            $("#lblError2").delay(5000).hide(100);
            return;
          }
          if (this.roundtripSearchObj.prefferedAirline2 == this.roundtripSearchObj.prefferedAirline3
            && this.roundtripSearchObj.prefferedAirline2 != "" && this.roundtripSearchObj.prefferedAirline3 != ""
            && this.roundtripSearchObj.prefferedAirline2 != null && this.roundtripSearchObj.prefferedAirline3 != null
            && this.roundtripSearchObj.prefferedAirline2 != undefined && this.roundtripSearchObj.prefferedAirline3 != undefined) {
            $("#lblError2").show();
            document.getElementById("lblError2").style.color = "#FE2C02";
            document.getElementById("lblError2").innerHTML = "You Cannot  Select Same Preffed Airlines"
            $("#lblError2").delay(5000).hide(100);
            return;
          }
          if (this.roundtripSearchObj.prefferedAirline1 == null) {
            this.roundtripSearchObj.prefferedAirline1 = "";
          }
          if (this.roundtripSearchObj.prefferedAirline2 == null) {
            this.roundtripSearchObj.prefferedAirline2 = "";
          }
          if (this.roundtripSearchObj.prefferedAirline3 == null) {
            this.roundtripSearchObj.prefferedAirline3 = "";
          }
        }
        //end
        document.getElementById("lblError2").style.display = "none";
        // alert(new Date(this.roundtripSearchObj.departureTime).toString());
        if (new Date(this.roundtripSearchObj.departureTime).toString() == "Invalid Date") {

          let departureDate = this.roundtripSearchObj.departureTime.split('/');
          let departure = (departureDate[2]) + "-" + (departureDate[1]) + "-" + (departureDate[0]);
          this.departureDates = new Date(departure);

        }
        //else if (this.roundtripSearchObj.departureTime.includes("/") )
        //{

        //  let departureDate = this.roundtripSearchObj.departureTime.split('/');
        //  let departure = (departureDate[2]) + "-" + (departureDate[1]) + "-" + (departureDate[0]);
        //  this.departureDates = new Date(departure);

        //}
        else {

          let departureDate = this.roundtripSearchObj.departureTime.toString().split('/');
          if (departureDate.length == 3) {

            //let departureDate = this.roundtripSearchObj.departureTime.split('/');
            let departure = (departureDate[2]) + "-" + (departureDate[1]) + "-" + (departureDate[0]);
            this.departureDates = new Date(departure);

          }
          else
            this.departureDates = new Date(this.roundtripSearchObj.departureTime);
        }

        if (new Date(this.roundtripSearchObj.returnDate).toString() == "Invalid Date") {
          let returnDate = this.roundtripSearchObj.returnDate.split('/');
          let datereturn = (returnDate[2]) + "-" + (returnDate[1]) + "-" + (returnDate[0]);
          this.returnDates = new Date(datereturn);
        }
        //else 
        else {
          let returnDate = this.roundtripSearchObj.returnDate.toString().split('/');
          if (returnDate.length == 3) {
            //let returnDate = this.roundtripSearchObj.returnDate.split('/');
            let datereturn = (returnDate[2]) + "-" + (returnDate[1]) + "-" + (returnDate[0]);
            this.returnDates = new Date(datereturn);
          }
          else
            this.returnDates = new Date(this.roundtripSearchObj.returnDate);
        }
        //if (this.departureDates > this.returnDates) {
        //  document.getElementById("roundTripDateError").style.display = "block";
        //  document.getElementById("roundTripDateError").style.color = "#FE2C02";
        //  document.getElementById("roundTripDateError").innerHTML = "Return Date Must be Greater Than or Equal to Departure";
        //  setTimeout(() => {
        //    document.getElementById("roundTripDateError").style.display = "none";
        //    document.getElementById("roundTripDateError").innerHTML = "";
        //  }, 6000)
        //}
        //else
        {


          if (this.haveRights) {


            let formatedReturnDate;
            this.searchObj = new FlightSearchProperties();
            try {
              let retD = this.roundtripSearchObj.returnDate;
              let days = retD.slice(0, 2);
              let month = retD.slice(3, 5);
              let year = retD.slice(6);
              formatedReturnDate = year + "-" + month + "-" + days;
            }
            catch (e) {
              let arrPipe: DatePipe = new DatePipe('en-US');
              formatedReturnDate = arrPipe.transform(this.roundtripSearchObj.returnDate, "yyyy-MM-dd");
            }
            let departCheck = new Date(this.roundTripDeparture);
            let returnCheck = new Date(formatedReturnDate);
            if (returnCheck < departCheck) {
              $("#lblError1RT").show();
              document.getElementById("lblError1RT").style.color = "#FE2C02";
              document.getElementById("lblError1RT").innerHTML = "You can not return before you depart.";
              $("#lblError1RT").delay(5000).hide(100);
              return false;
            }
            this.searchObj.agencyID = localStorage.getItem("AgencyId");
            this.searchObj.days = this.roundwayDuration;
            this.searchObj.returnDate = formatedReturnDate;
            this.searchObj.adult = this.roundtripSearchObj.adult;
            this.searchObj.infant = this.roundtripSearchObj.infant;
            this.searchObj.child = this.roundtripSearchObj.child;
            this.searchObj.fareType = this.roundtripSearchObj.fareType;
            this.searchObj.cabinClass = this.roundtripSearchObj.cabinClass;
            this.searchObj.nonStopFlight = this.roundtripSearchObj.nonStopFlight;
            this.searchObj.nearByAirport = this.roundtripSearchObj.nearByAirport;
            this.searchObj.lowCostAirline = this.roundtripSearchObj.lowCostAirline;
            this.searchObj.gdsAirline = this.roundtripSearchObj.gdsAirline;
            this.searchObj.prefferedAirline1 = this.roundtripSearchObj.prefferedAirline1
            this.searchObj.prefferedAirline2 = this.roundtripSearchObj.prefferedAirline2;
            this.searchObj.prefferedAirline3 = this.roundtripSearchObj.prefferedAirline3;
            this.searchObj.tripType = "single-round";
            if (this.roundtripSearchObj.adult == null) {
              this.searchObj.adult = 0;
            }
            if (this.roundtripSearchObj.infant == null) {
              this.searchObj.infant = 0;
            }

            if (this.roundtripSearchObj.child == null) {
              this.searchObj.child = 0;
            }
            for (let n = 0; n < this.childAgeListOfR.length; n++) {
              this.searchObj.childAges.push(String(this.childAgeListOfR[n].childAge));
            }

            for (let q = 0; q < this.infantAgeListOfR.length; q++) {
              this.searchObj.infantAges.push(this.infantAgeListOfR[q].infantAge);
              if (this.searchObj.infantAges[q] == "less than 1") {
                this.searchObj.infantAges[q] = "0";
              }
              else if (this.roundtripSearchObj.infant == 0) {
                this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);
              }
            }
            // let obj = new FlightSearchDestinationProperties();
            for (let p = 0; p < this.searchObj.childAges.length; p++) {

              // ======= Asad Working ==========
              if (this.searchObj.child > 0 && (this.searchObj.childAges[p].includes("undefined") || this.searchObj.childAges[p].includes("null"))) {

                // this.searchObj.child > 0 && (this.searchObj.childAges[p].includes("undefined") || this.searchObj.childAges[p].includes("null")

                let errorDiv = document.getElementById("lblError1");
                console.log(errorDiv);

                $("#lblError2").show();
                document.getElementById("lblError2").style.color = "#FE2C02";
                document.getElementById("lblError2").innerHTML = "Please select ages for Child(ren).";
                $("#lblError2").delay(5000).hide(100);


                //$("#lblError1").show();
                //document.getElementById("lblError1").style.color = "#FE2C02";
                //document.getElementById("lblError1").innerHTML = "Please select ages for Child(ren).";
                //$("#lblError1").delay(5000).hide(100);

                return false;

              }

            }

            for (let q = 0; q < this.searchObj.infantAges.length; q++) {

              // ==== Asad Working =======
              if (this.searchObj.infant > 0 && (this.searchObj.infantAges[q] === null || this.searchObj.infantAges[q] === undefined)) {
                $("#lblError2").show();

                document.getElementById("lblError2").style.color = "#FE2C02";

                document.getElementById("lblError2").innerHTML = "Please select ages for Infant(s).";

                $("#lblError2").delay(5000).hide(100);

                return false;

              }

            }
            let start = this.roundTripFrom.indexOf(this.roundTripFrom[0]);
            let end = this.roundTripFrom.indexOf('-');
            this.roundwayFcity = this.roundTripFrom.slice(start, end);
            this.destinationObj.fromAirport = this.roundTripFrom;

            let start1 = this.roundTripTo.indexOf(this.roundTripTo[0]);
            let end2 = this.roundTripTo.indexOf('-');
            this.roundwayTcity = this.roundTripTo.slice(start, end);
            this.destinationObj.toAirport = this.roundTripTo;

            this.destinationObj.fromCity = this.roundwayFcity;
            this.destinationObj.toCity = this.roundwayTcity;
            this.destinationObj.departureDate = this.roundTripDeparture;
            //19-july-23

            for (let i = 0; i < this.airportList.length; i++) {
              if (this.roundwayFcity.trim() == this.airportList[i].iatA_CODE) {
                this.destinationObj.combineAirportFrom = this.airportList[i].combineAirportFrom;
                break;
              }

            }
            for (let i = 0; i < this.airportList.length; i++) {
              if (this.roundwayTcity.trim() == this.airportList[i].iatA_CODE) {
                this.destinationObj.combineAirportTo = this.airportList[i].combineAirportTo;
                break;
              }

            }

            //this.destinationObj.combineAirportTo=this.destinationObj.toCity.trim()+",";


            //end
            this.searchObj.flightLocationInfo.push(this.destinationObj);
            let obj = new FlightSearchDestinationProperties();
            obj.fromAirport = this.roundTripTo;
            obj.toAirport = this.roundTripFrom;

            obj.fromCity = this.roundwayTcity;
            obj.toCity = this.roundwayFcity;
            obj.departureDate = formatedReturnDate;
            //19-july-23
            for (let i = 0; i < this.airportList.length; i++) {
              if (obj.fromCity.trim() == this.airportList[i].iatA_CODE) {
                obj.combineAirportFrom = this.airportList[i].combineAirportFrom;
                break;
              }

            }



            for (let i = 0; i < this.airportList.length; i++) {
              if (obj.toCity.trim() == this.airportList[i].iatA_CODE) {
                obj.combineAirportTo = this.airportList[i].combineAirportTo;
                break;
              }

            }
            // obj.combineAirportTo=obj.toCity.trim()+",";

            //end

            this.searchObj.flightLocationInfo.push(obj);

            this.searchObj.journeyType = 2;
            localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));
            this.router.navigateByUrl('/flightResults');

          }
          else {

            $("#lblError2").show();
            document.getElementById("lblError2").style.color = "#FE2C02";
            document.getElementById("lblError2").innerHTML = "You don't have right to perform search."
            $("#lblError2").delay(5000).hide(100);
            return false;

          }


        }
      }
      else {

        //document.getElementById("lblError2").style.display = "block";
        //setTimeout(() => {
        //  document.getElementById("lblError2").style.display = "none";
        //}, 6000)

        //return false;
      }

    }
    catch (e) {
      console.log(e);
    }
  }



  MultiCitySearchClick() {
    try {
      if (this.MulticityValidation()) {
        //26-july-23
        if (this.multiCitySearchObj.prefferedAirline1 != "" || this.multiCitySearchObj.prefferedAirline2 != "" || this.multiCitySearchObj.prefferedAirline3 != "") {
          if (this.multiCitySearchObj.prefferedAirline1 == this.multiCitySearchObj.prefferedAirline2
            && this.multiCitySearchObj.prefferedAirline1 != "" && this.multiCitySearchObj.prefferedAirline2 != ""
            && this.multiCitySearchObj.prefferedAirline1 != null && this.multiCitySearchObj.prefferedAirline2 != null
            && this.multiCitySearchObj.prefferedAirline1 != undefined && this.multiCitySearchObj.prefferedAirline2 != undefined) {
            $("#lblError3").show();
            document.getElementById("lblError3").style.color = "#FE2C02";
            document.getElementById("lblError3").innerHTML = "You Cannot Select Same Preffed Airlines"
            $("#lblError3").delay(5000).hide(100);
            return;
          }
          if (this.multiCitySearchObj.prefferedAirline1 == this.multiCitySearchObj.prefferedAirline3
            && this.multiCitySearchObj.prefferedAirline1 != "" && this.multiCitySearchObj.prefferedAirline3 != ""
            && this.multiCitySearchObj.prefferedAirline1 != null && this.multiCitySearchObj.prefferedAirline3 != null
            && this.multiCitySearchObj.prefferedAirline1 != undefined && this.multiCitySearchObj.prefferedAirline3 != undefined) {
            $("#lblError3").show();
            document.getElementById("lblError3").style.color = "#FE2C02";
            document.getElementById("lblError3").innerHTML = "You Cannot Select Same Preffed Airlines"
            $("#lblError3").delay(5000).hide(100);
            return;
          }
          if (this.multiCitySearchObj.prefferedAirline2 == this.multiCitySearchObj.prefferedAirline3
            && this.multiCitySearchObj.prefferedAirline2 != "" && this.multiCitySearchObj.prefferedAirline3 != ""
            && this.multiCitySearchObj.prefferedAirline2 != null && this.multiCitySearchObj.prefferedAirline3 != null
            && this.multiCitySearchObj.prefferedAirline2 != undefined && this.multiCitySearchObj.prefferedAirline3 != undefined) {
            $("#lblError3").show();
            document.getElementById("lblError3").style.color = "#FE2C02";
            document.getElementById("lblError3").innerHTML = "You Cannot  Select Same Preffed Airlines"
            $("#lblError3").delay(5000).hide(100);
            return;
          }
          if (this.multiCitySearchObj.prefferedAirline1 == null) {
            this.multiCitySearchObj.prefferedAirline1 = "";
          }
          if (this.multiCitySearchObj.prefferedAirline2 == null) {
            this.multiCitySearchObj.prefferedAirline2 = "";
          }
          if (this.multiCitySearchObj.prefferedAirline3 == null) {
            this.multiCitySearchObj.prefferedAirline3 = "";
          }
        }
        //end
        document.getElementById("lblError3").style.display = "none";
        document.getElementById("lblError3").innerHTML = "";
        if (this.haveRights && this.defaultMulticityDiv.length > 1) {

          this.searchObj = new FlightSearchProperties();
          this.searchObj.agencyID = localStorage.getItem("AgencyId");

          this.searchObj.adult = this.multiCitySearchObj.adult;

          this.searchObj.infant = this.multiCitySearchObj.infant;

          this.searchObj.child = this.multiCitySearchObj.child;

          this.searchObj.tripType = "multi";

          this.searchObj.fareType = this.multiCitySearchObj.fareType;

          this.searchObj.cabinClass = this.multiCitySearchObj.cabinClass;

          this.searchObj.nonStopFlight = this.multiCitySearchObj.nonStopFlight;

          this.searchObj.prefferedAirline1 = this.multiCitySearchObj.prefferedAirline1;

          this.searchObj.prefferedAirline2 = this.multiCitySearchObj.prefferedAirline2;

          this.searchObj.prefferedAirline3 = this.multiCitySearchObj.prefferedAirline3;
          if (this.multiCitySearchObj.adult == null) {
            this.searchObj.adult = 0;
          }

          if (this.multiCitySearchObj.infant == null) {
            this.searchObj.infant = 0;
          }

          if (this.multiCitySearchObj.child == null) {
            this.searchObj.child = 0;
          }


          for (let n = 0; n < this.childAgeListOfM.length; n++) {

            this.searchObj.childAges.push(String(this.childAgeListOfM[n].childAge));

          }

          for (let q = 0; q < this.infantAgeListOfM.length; q++) {

            this.searchObj.infantAges.push(this.infantAgeListOfM[q].infantAge);

            if (this.searchObj.infantAges[q] == "less than 1") {

              this.searchObj.infantAges[q] = "0";

            }

            else if (this.multiCitySearchObj.infant == 0) {

              this.searchObj.infantAges.splice(0, this.searchObj.infantAges.length);

            }

          }

          for (let p = 0; p < this.searchObj.childAges.length; p++) {

            // if (this.searchObj.child > 0 && this.searchObj.childAges[p].includes("undefined"))

            // ==== Asad Working =======
            if (this.searchObj.child > 0 && (this.searchObj.childAges[p].includes("undefined") || this.searchObj.childAges[p].includes("null"))) {

              $("#lblError3").show();
              document.getElementById("lblError3").style.color = "#FE2C02";
              document.getElementById("lblError3").innerHTML = "Please select ages for Child(ren).";
              $("#lblError3").delay(5000).hide(100);

              return false;

            }

          }



          for (let q = 0; q < this.searchObj.infantAges.length; q++) {

            // if (this.searchObj.infant > 0 && this.searchObj.infantAges[q].includes("undefined"))

            // ==== Asad Working =======
            if (this.searchObj.infant > 0 && (this.searchObj.infantAges[q] === null || this.searchObj.infantAges[q] === undefined)) {

              $("#lblError3").show();
              document.getElementById("lblError3").style.color = "#FE2C02";
              document.getElementById("lblError3").innerHTML = "Please select ages for Infant(s).";
              $("#lblError3").delay(5000).hide(100);

              return false;

            }

          }

          this.searchObj.flightLocationInfo = this.defaultMulticityDiv;



          for (let i = 0; i < this.searchObj.flightLocationInfo.length; i++) {

            let start = this.searchObj.flightLocationInfo[i].fromAirport.indexOf(this.searchObj.flightLocationInfo[i].fromAirport[0]);

            let end = this.searchObj.flightLocationInfo[i].fromAirport.indexOf('-');

            this.searchObj.flightLocationInfo[i].fromCity = this.searchObj.flightLocationInfo[i].fromAirport.slice(start, end).trim();



            if (this.searchObj.flightLocationInfo[i].departureDate.toString().includes("/")) {

              let retD = this.searchObj.flightLocationInfo[i].departureDate;

              let days = retD.slice(0, 2);

              let month = retD.slice(3, 5);

              let year = retD.slice(6);

              this.searchObj.flightLocationInfo[i].departureDate = year + "-" + month + "-" + days;

            } else {

              let modiObjRTPipe: DatePipe = new DatePipe('en-US');

              this.searchObj.flightLocationInfo[i].departureDate = (modiObjRTPipe.transform(this.searchObj.flightLocationInfo[i].departureDate, "yyyy-MM-dd"));

            }
            //19-july-23
            let start1 = this.searchObj.flightLocationInfo[i].toAirport.indexOf(this.searchObj.flightLocationInfo[i].toAirport[0]);

            let end1 = this.searchObj.flightLocationInfo[i].toAirport.indexOf('-');

            this.searchObj.flightLocationInfo[i].toCity = this.searchObj.flightLocationInfo[i].toAirport.slice(start1, end1).trim();


            for (let j = 0; j < this.airportList.length; j++) {
              if (this.searchObj.flightLocationInfo[i].fromCity.trim() == this.airportList[j].iatA_CODE) {
                this.searchObj.flightLocationInfo[i].combineAirportFrom = this.airportList[j].combineAirportFrom;
                break;
              }

            }
            for (let k = 0; k < this.airportList.length; k++) {
              if (this.searchObj.flightLocationInfo[i].toCity.trim() == this.airportList[k].iatA_CODE) {
                this.searchObj.flightLocationInfo[i].combineAirportTo = this.airportList[k].combineAirportTo;
                break;
              }

            }
            //end


          }


          this.searchObj.journeyType = 3;
          //26-july-23
          this.searchObj.gdsAirline = this.multiCitySearchObj.gdsAirline;
          this.searchObj.lowCostAirline = this.multiCitySearchObj.lowCostAirline;
          this.searchObj.nearByAirport = this.multiCitySearchObj.nearByAirport;
          //end
          localStorage.setItem('flightSearchData', JSON.stringify(this.searchObj));

          this.router.navigateByUrl('/flightResults');

        }

        else {

          $("#lblError3").show();

          document.getElementById("lblError3").style.color = "#FE2C02";

          document.getElementById("lblError3").innerHTML = "You don't have right to perform search."

          $("#lblError3").delay(5000).hide(100);

          return false;

        }
      }
      else {

        //document.getElementById("lblError3").style.display = "block";
        ////document.getElementById("lblError3").innerHTML = "Please Enter Required Fields ";
        //document.getElementById("lblError3").innerHTML = "Please Enter Required Fields ";
        //setTimeout(() => {
        //  document.getElementById("lblError3").style.display = "none";
        //  document.getElementById("lblError3").innerHTML = "";
        //}, 6000)


        //return false;
      }

    }

    catch (e) {
      console.log(e)
    }

  }








}
